import { AT } from "./types";

/**
 * Copyright (c) Microsoft Corporation. All rights reserved.  
 * Licensed under the MIT License.
 */
export enum FM {
    ABOUT_TITLE = 'About.title',
    DOCS_TITLE = 'Docs.title',
    LOGIN_TITLE = 'Login.title',
    PROFILE_TITLE = 'Profile.title',
    PROFILE_NAME = 'Profile.name',
    PROFILE_SETTINGS_TITLE = 'Profile.settings.title',
    PROFILE_SETTINGS_BOT_PORT = 'Profile.settings.sdkPort',
    PROFILE_SETTINGS_BOT_PORT_DESCRIPTION = 'Profile.settings.sdkPort.description',
    PROFILE_SETTINGS_BOT_PORT_USE_CUSTOM = 'Profile.settings.useCustomPort',
    PROFILE_SETTINGS_BOT_PORT_WARNING = 'Profile.settings.sdkPortWarning',
    SUPPORT_TITLE = 'Support.title',
    NOMATCH_TITLE = 'NoMatch.title',
    NOMATCH_HOME = 'NoMatch.home',
    PAGE_COMINGSOON = 'page.comingsoon',

    // Actions
    ACTIONS_TITLE = 'Actions.title',
    ACTIONS_SUBTITLE = 'Actions.subtitle',
    ACTIONS_CREATEBUTTONARIADESCRIPTION = 'Actions.createButtonAriaDescription',
    ACTIONS_CREATEBUTTONTITLE = 'Actions.createButtonTitle',

    // ActionCreatorEditor
    ACTIONCREATOREDITOR_SAVEBUTTON_ARIADESCRIPTION = 'ActionCreatorEditor.saveButton.ariaDescription',
    ACTIONCREATOREDITOR_SAVEBUTTON_TEXT = 'ActionCreatorEditor.saveButton.text',
    ACTIONCREATOREDITOR_CREATEBUTTON_ARIADESCRIPTION = 'ActionCreatorEditor.createButton.ariaDescription',
    ACTIONCREATOREDITOR_CREATEBUTTON_TEXT = 'ActionCreatorEditor.createButton.text',
    ACTIONCREATOREDITOR_CANCELBUTTON_ARIADESCRIPTION = 'ActionCreatorEditor.cancelButton.ariaDescription',
    ACTIONCREATOREDITOR_CANCELBUTTON_TEXT = 'ActionCreatorEditor.cancelButton.text',
    ACTIONCREATOREDITOR_DONEBUTTON_ARIADESCRIPTION = 'ActionCreatorEditor.doneButton.ariaDescription',
    ACTIONCREATOREDITOR_DONEBUTTON_TEXT = 'ActionCreatorEditor.doneButton.text',
    ACTIONCREATOREDITOR_DELETEBUTTON_ARIADESCRIPTION = 'ActionCreatorEditor.deleteButton.ariaDescription',
    ACTIONCREATOREDITOR_DELETEBUTTON_TEXT = 'ActionCreatorEditor.deleteButton.text',
    ACTIONCREATOREDITOR_TRAINDIALOGSBUTTON_ARIADESCRIPTION = 'ActionCreatorEditor.traindialogsButton.ariaDescription',
    ACTIONCREATOREDITOR_TRAINDIALOGSBUTTON_TEXT = 'ActionCreatorEditor.traindialogsButton.text',
    ACTIONCREATOREDITOR_CONFIRM_DELETE_TITLE = 'ActionCreatorEditor.confirmDeleteTitle',
    ACTIONCREATOREDITOR_CONFIRM_DELETE_WARNING = 'ActionCreatorEditor.confirmDeleteWarning',
    ACTIONCREATOREDITOR_CONFIRM_EDIT_TITLE = 'ActionCreatorEditor.confirmEditTitle',
    ACTIONCREATOREDITOR_CONFIRM_EDIT_WARNING = 'ActionCreatorEditor.confirmEditWarning',
    ACTIONCREATOREDITOR_CONFIRM_MISSINGLABEL_WARNING = 'ActionCreatorEditor.confirmMissingLabelWarning',
    ACTIONCREATOREDITOR_WARNING_ENTITY = 'ActionCreatorEditor.warningEntity',
    ACTIONCREATOREDITOR_WARNING_PAYLOAD = 'ActionCreatorEditor.warningPayload',
    ACTIONCREATOREDITOR_WARNING_NONEMPTYFIELD = 'ActionCreatorEditor.warningNonEmptyFields',
    ACTIONCREATOREDITOR_WARNING_DUPLICATEACTION = 'ActionCreatorEditor.warningDuplicateAction',
    ACTIONCREATOREDITOR_WARNING_DUPLICATEFOUND = 'ActionCreatorEditor.warningDuplicateFound',
    ACTIONCREATOREDITOR_WARNING_SET_ENTITY_CREATION = 'ActionCreationEditor.warningSetEntityCreation',
    ACTIONCREATOREDITOR_WARNING_SET_ENTITY_EDIT = 'ActionCreatorEditor.warningSetEntityEdit',

    // ActionDeleteModal
    ACTION_DELETE_INUSE_TITLE = 'ActionDelete.inUse.title',
    ACTION_DELETE_INUSE_PLACEHOLDER_PRESERVE = 'ActionDelete.inUse.placeholderPreserve',
    ACTION_DELETE_INUSE_PLACEHOLDER_REMOVE = 'ActionDelete.inUse.placeholderRemove', 

    // ActionDetails
    ACTIONDETAILSLIST_COLUMNS_RESPONSE = 'ActionDetailsList.columns.response',
    ACTIONDETAILSLIST_COLUMNS_ARGUMENTS = 'ActionDetailsList.columns.arguments',
    ACTIONDETAILSLIST_COLUMNS_TYPE = 'ActionDetailsList.columns.type',
    ACTIONDETAILSLIST_COLUMNS_REQUIREDENTITIES = 'ActionDetailsList.columns.requiredEntities',
    ACTIONDETAILSLIST_COLUMNS_DISQUALIFYINGENTITIES = 'ActionDetailsList.columns.disqualifyingEntities',
    ACTIONDETAILSLIST_COLUMNS_SUGGESTEDENTITY = 'ActionDetailsList.columns.suggestedEntity',
    ACTIONDETAILSLIST_COLUMNS_ISTERMINAL = 'ActionDetailsList.columns.isTerminal',
    ACTIONDETAILSLIST_COLUMNS_CREATED_DATE_TIME = 'ActionDetailsList.columns.createdDateTime',

    // ActionScorer
    ACTIONSCORER_COLUMNS_RESPONSE = 'ActionScorer.columns.response',
    ACTIONSCORER_COLUMNS_ARGUMENTS = 'ActionScorer.columns.arguments',
    ACTIONSCORER_COLUMNS_SCORE = 'ActionScorer.columns.score',
    ACTIONSCORER_COLUMNS_ENTITIES = 'ActionScorer.columns.entities',
    ACTIONSCORER_COLUMNS_ISTERMINAL = 'ActionScorer.columns.isTerminal',
    ACTIONSCORER_COLUMNS_TYPE = 'ActionScorer.columns.type',

    // App
    APP_HEADER_MODELS = 'App.header.home',
    APP_HEADER_ABOUT = 'App.header.about',
    APP_HEADER_DOCS = 'App.header.docs',
    APP_HEADER_SUPPORT = 'App.header.support',

    APP_VERSION = 'App.version',

    // TrainingStatus
    APP_TRAINING_STATUS_STATUS = 'TrainingStatus.status.label',
    APP_TRAINING_STATUS_UNKNOWN = 'TrainingStatus.status.unknown',
    APP_TRAINING_STATUS_QUEUED = 'TrainingStatus.status.queued',
    APP_TRAINING_STATUS_RUNNING = 'TrainingStatus.status.running',
    APP_TRAINING_STATUS_COMPLETED = 'TrainingStatus.status.completed',
    APP_TRAINING_STATUS_FAILED = 'TrainingStatus.status.failed',
    APP_TRAINING_STATUS_LAST_UPDATE = 'TrainingStatus.lastupdate',
    APP_TRAINING_STATUS_REFRESH = 'TrainingStatus.refresh',
    APP_TRAINING_STATUS_EXPIRED = 'TrainingStatus.expired',

    // AppCreator
    APPCREATOR_FIELDERROR_REQUIREDVALUE = 'AppCreator.fieldError.requiredValue',
    APPCREATOR_FIELDERROR_ALPHANUMERIC = 'AppCreator.fieldError.alphanumeric',
    APPCREATOR_FIELDERROR_DISTINCT = 'AppCreator.fieldError.distinct',
    APPCREATOR_FIELDERROR_TOOLONG = 'AppCreator.fieldError.toolong',
    APPCREATOR_TITLE = 'AppCreator.title',
    APPCREATOR_COPY_TITLE = 'AppCreator.copytitle',
    APPCREATOR_IMPORT_TITLE = 'AppCreator.importtitle',
    APPCREATOR_FIELDS_NAME_LABEL = 'AppCreator.fields.name.label',
    APPCREATOR_FIELDS_IMPORT_NAME_LABEL = 'AppCreator.fields.importname.label',
    APPCREATOR_FIELDS_NAME_PLACEHOLDER = 'AppCreator.fields.name.placeholder',
    APPCREATOR_FIELDS_LOCALE_LABEL = 'AppCreator.fields.locale.label',
    APPCREATOR_COPYBUTTON_ARIADESCRIPTION = 'AppCreator.copyButton.ariaDescription',
    APPCREATOR_COPYBUTTON_TEXT = 'AppCreator.copyButton.text',
    APPCREATOR_CREATEBUTTON_ARIADESCRIPTION = 'AppCreator.createButton.ariaDescription',
    APPCREATOR_CREATEBUTTON_TEXT = 'AppCreator.createButton.text',
    APPCREATOR_IMPORT_BUTTON_ARIADESCRIPTION = 'AppCreator.importButton.ariaDescription',
    APPCREATOR_IMPORT_BUTTON_TEXT = 'AppCreator.importButton.text',
    APPCREATOR_CHOOSE_FILE_BUTTON_ARIADESCRIPTION = 'AppCreator.chooseFileButton.ariaDescription',
    APPCREATOR_CHOOSE_FILE_BUTTON_TEXT = 'AppCreator.chooseFileButton.text',
    APPCREATOR_CANCELBUTTON_ARIADESCRIPTION = 'AppCreator.cancelButton.ariaDescription',
    APPCREATOR_CANCELBUTTON_TEXT = 'AppCreator.cancelButton.text',

    // Apps List
    APPSLIST_SUBTITLE = 'AppsList.subtitle',
    APPSLIST_CREATEBUTTONARIADESCRIPTION = 'AppsList.createButtonAriaDescription',
    APPSLIST_CREATEBUTTONTEXT = 'AppsList.createButtonText',
    APPSLIST_EMPTY_TEXT = 'AppsList.emptyText',
    APPSLIST_IMPORTAPP_BUTTONARIADESCRIPTION = 'AppsList.importappButtonAriaDescription',
    APPSLIST_IMPORTAPP_BUTTONTEXT = 'AppsList.importappButtonText',
    APPSLIST_IMPORTTUTORIALS_BUTTONARIADESCRIPTION = 'AppsList.importtutorialsButtonAriaDescription',
    APPSLIST_IMPORTTUTORIALS_BUTTONTEXT = 'AppsList.importtutorialsButtonText',
    APPSLIST_CONFIRMCANCELMODALTITLE = 'AppsList.confirmCancelModalTitle',
    APPSLIST_COLUMN_NAME = 'AppsList.columns.name',
    APPSLIST_COLUMNS_LOCALE = 'AppsList.columns.locale',
    APPSLIST_COLUMNS_LINKEDBOTS = 'AppsList.columns.linkedBots',
    APPSLIST_COLUMNS_CREATED_DATE_TIME = 'AppsList.columns.createdDateTime',
    APPSLIST_COLUMNS_LAST_MODIFIED_DATE_TIME = 'AppsList.columns.lastModifiedDateTime',
    APPSLIST_COLUMNS_LOGGING = 'AppsList.columns.logging',
    APPSLIST_COLUMNS_ACTIONS = 'AppsList.columns.actions',

    // Generic Buttons
    BUTTON_ABANDON = 'Button.ABANDON',
    BUTTON_ABANDON_EDIT = 'Button.ABANDON_EDIT',
    BUTTON_ABANDON_BRANCH = 'Button.ABANDON_BRANCH',
    BUTTON_ACCEPT = 'Button.ACCEPT',
    BUTTON_CANCEL = 'Button.CANCEL',
    BUTTON_CLOSE = 'Button.CLOSE',
    BUTTON_DELETE = 'Button.DELETE',
    BUTTON_INFO = 'Button.INFO',
    BUTTON_IMPORT = 'Button.IMPORT',
    BUTTON_OK = 'Button.OK',
    BUTTON_REPLAY = 'Button.REPLAY',
    BUTTON_SAVE = 'Button.SAVE',
    BUTTON_SAVE_AS_TRAIN_DIALOG = 'Button.SAVE_AS_TD',
    BUTTON_SAVE_EDIT = 'Button.SAVE_EDIT',
    BUTTON_SAVE_BRANCH = 'Button.SAVE_BRANCH',
    BUTTON_SUBMIT = 'Button.SUMBIT',
    BUTTON_UNDO = 'Button.UNDO',
    BUTTON_SELECT = 'Button.SELECT',
    BUTTON_SELECTED = 'Button.SELECTED',
    BUTTON_NEXT = 'Button.next',
    BUTTON_PREVIOUS = 'Button.previous',

    // ChatSessionModal
    CHATSESSIONMODAL_PRIMARYBUTTON_ARIADESCRIPTION = 'ChatSessionModal.primaryButton.ariaDescription',
    CHATSESSIONMODAL_PRIMARYBUTTON_TEXT = 'ChatSessionModal.primaryButton.text',
    CHATSESSIONMODAL_EXPIREBUTTON_ARIADESCRIPTION = 'ChatSessionModal.expireButton.ariaDescription',
    CHATSESSIONMODAL_EXPIREBUTTON_TEXT = 'ChatSessionModal.expireButton.text',
    CHATSESSIONMODAL_TIMEOUT_TITLE = 'ChatSessionModal.timeout.title',

    // ConfirmCancelModal
    CONFIRMCANCELMODAL_PRIMARYBUTTON_TEXT = 'ConfirmCancelModal.primaryButton.text',
    CONFIRMCANCELMODAL_DEFAULTBUTTON_TEXT = 'ConfirmCancelModal.defaultButton.text',

    // Custom Errors
    CUSTOMERROR_NETWORK_ERROR = 'CustomError.networkError',

    // Dashboard
    DASHBOARD_TITLE = 'Dashboard.title',
    DASHBOARD_SUBTITLE = 'Dashboard.subtitle',

    // DialogMetadata
    DIALOGMETADATA_TAGS_LABEL = 'DialogMetadata.Tags.label',
    DIALOGMETADATA_DESCRIPTION_LABEL = 'DialogMetadata.Description.label',
    DIALOGMETADATA_DESCRIPTION_PLACEHOLDER = 'DialogMetadata.Description.placeholder',
    DIALOGMETADATA_USERINPUT_LABEL = 'DialogMetadata.UserInput.label',
    DIALOGMETADATA_ALTINPUT_LABEL = 'DialogMetadata.AltInput.label',

    // DemoImporter
    DEMOIMPORT_TITLE = 'DemoImporter.title',
    DEMOIMPORT_BUTTON_ARIADESCRIPTION = 'DemoImporter.button.ariaDescription',
    DEMOIMPORT_BUTTON_TEXT = 'DemoImporter.button.text',

    // EditDialogAdmin
    EDITDIALOGADMIN_DIALOGMODE_USER = 'EditDialogAdmin.dialogMode.user',
    EDITDIALOGADMIN_DIALOGMODE_TEXT = 'EditDialogAdmin.dialogMode.text',
    EDITDIALOGADMIN_MEMORY_TITLE = 'EditDialogAdmin.memory.title',
    EDITDIALOGADMIN_HELPTEXT_TITLE_LOG = 'EditDialogAdmin.helpText.title.log',
    EDITDIALOGADMIN_HELPTEXT_DESCRIPTION_LOG = 'EditDialogAdmin.helpText.description.log',
    EDITDIALOGADMIN_HELPTEXT_DESCRIPTION2_LOG = 'EditDialogAdmin.helpText.description2.log',
    EDITDIALOGADMIN_HELPTEXT_TITLE_TRAIN = 'EditDialogAdmin.helpText.title.train',
    EDITDIALOGADMIN_HELPTEXT_DESCRIPTION_TRAIN = 'EditDialogAdmin.helpText.description.train',
    EDITDIALOGADMIN_HELPTEXT_DESCRIPTION2_TRAIN = 'EditDialogAdmin.helpText.description2.train',
    EDITDIALOGADMIN_ENTITYDETECTION_TITLE = 'EditDialogAdmin.entityDetection.title',
    EDITDIALOGADMIN_ENTITYDETECTION_HELPTEXT = 'EditDialogAdmin.entityDetection.helpText',
    EDITDIALOGADMIN_ACTION_TITLE = 'EditDialogAdmin.action.title',

    // EditDialogModal
    EDITDIALOGMODAL_BRANCH_ARIADESCRIPTION = 'EditDialogModal.branch.ariaDescription',
    EDITDIALOGMODAL_BRANCH_TEXT = 'EditDialogModal.branch.text',
    EDITDIALOGMODAL_BRANCH_TIP = 'EditDialogModal.branch.tip',
    EDITDIALOGMODAL_CANTBRANCH_TITLE = 'EditDialogModal.cantbranch.title',
    EDITDIALOGMODAL_CANTREPLAY_TITLE = 'EditDialogModal.cantreplay.title',
    EDITDIALOGMODAL_CONFIRMDELETELOG_TITLE = 'EditDialogModal.confirmDeleteLog.title',
    EDITDIALOGMODAL_CONFIRMDELETETRAIN_TITLE = 'EditDialogModal.confirmDeleteTrain.title',
    EDITDIALOGMODAL_CONFIRMABANDON_NEW_TITLE = 'EditDialogModal.confirmAbandonNew.title',
    EDITDIALOGMODAL_CONFIRMABANDON_EDIT_TITLE = 'EditDialogModal.confirmAbandonEdit.title',
    EDITDIALOGMODAL_SAVECONFLICT_TITLE = 'EditDialogModal.saveConflict.title',
    EDITDIALOGMODAL_WARNING_INVALID_BOT = 'EditDialogModal.warningInvalidBot.title',
    EDITDIALOGMODAL_WARNING_INVALID_PACKAGE = 'EditDialogModal.warningInvalidPackage.title',
    EDITDIALOGMODAL_UNKNOWN_NEED_REPLAY = 'EditDialogModal.unknownNeedReplay.title',
    EDITDIALOGMODAL_WARNING_NEED_REPLAY = 'EditDialogModal.warningNeedReplay.title',

    // Entities
    ENTITIES_TITLE = 'Entities.title',
    ENTITIES_SUBTITLE = 'Entities.subtitle',
    ENTITIES_CREATEBUTTONARIALDESCRIPTION = 'Entities.createButtonAriaDescription',
    ENTITIES_CREATEBUTTONTEXT = 'Entities.createButtonText',
    ENTITIES_COLUMNS_NAME = 'Entities.columns.name',
    ENTITIES_COLUMNS_TYPE = 'Entities.columns.type',
    ENTITIES_COLUMNS_RESOLVER = 'Entities.columns.resolver',
    ENTITIES_COLUMNS_IS_PROGRAMMATIC = 'Entities.columns.isProgrammatic',
    ENTITIES_COLUMNS_IS_BUCKETABLE = 'Entities.columns.isBucketable',
    ENTITIES_COLUMNS_IS_NEGATABLE = 'Entities.columns.isNegatable',
    ENTITIES_COLUMNS_CREATED_DATE_TIME = 'Entities.columns.createdDateTime',
    ENTITIES_CONFIRMCANCELMODALTITLE = 'Entities.confirmCancelModalTitle',

    // EntityCreatorEditor
    ENTITYCREATOREDITOR_FIELDERROR_NOBLANK = 'EntityCreatorEditor.fieldError.noblank',
    ENTITYCREATOREDITOR_FIELDERROR_MAX_LENGTH = 'EntityCreatorEditor.fieldError.maxLength',
    ENTITYCREATOREDITOR_FIELDERROR_REQUIREDVALUE = 'EntityCreatorEditor.fieldError.requiredValue',
    ENTITYCREATOREDITOR_FIELDERROR_ALPHANUMERIC = 'EntityCreatorEditor.fieldsError.alphanumerica',
    ENTITYCREATOREDITOR_FIELDERROR_DISTINCT = 'EntityCreatorEditor.fields.distinct',
    ENTITYCREATOREDITOR_FIELDERROR_RESERVED = 'EntityCreatorEditor.fields.reserved',
    ENTITYCREATOREDITOR_ENTITYOPTION_ENUM = 'EntityCreatorEditor.entityOption.enum',
    ENTITYCREATOREDITOR_ENTITYOPTION_LUIS = 'EntityCreatorEditor.entityOption.new',
    ENTITYCREATOREDITOR_ENTITYOPTION_PROG = 'EntityCreatorEditor.entityOption.programmatic',
    ENTITYCREATOREDITOR_ENTITY_RESOLVEROPTION_NONE = 'EntityCreatorEditor.entity.resolverOption.none',
    ENTITYCREATOREDITOR_TITLE_CREATE = 'EntityCreatorEditor.title.create',
    ENTITYCREATOREDITOR_TITLE_EDIT = 'EntityCreatorEditor.title.edit',
    ENTITYCREATOREDITOR_FIELDS_ENUM_LABEL = 'EntityCreatorEditor.fields.enum.label',
    ENTITYCREATOREDITOR_FIELDS_NAME_LABEL = 'EntityCreatorEditor.fields.name.label',
    ENTITYCREATOREDITOR_FIELDS_NAME_PLACEHOLDER = 'EntityCreatorEditor.fields.name.placeholder',
    ENTITYCREATOREDITOR_FIELDS_TYPE_LABEL = 'EntityCreatorEditor.fields.type.label',
    ENTITYCREATOREDITOR_FIELDS_RESOLVER_LABEL = 'EntityCreatorEditor.fields.resolver.label',
    ENTITYCREATOREDITOR_FIELDS_PROGRAMMATICONLY_LABEL = 'EntityCreatorEditor.fields.programmatically.label',
    ENTITYCREATOREDITOR_FIELDS_PROGRAMMATICONLY_HELPTEXT = 'EntityCreatorEditor.fields.programmatically.helptext',
    ENTITYCREATOREDITOR_FIELDS_TOOLTIPTARGET = 'EntityCreatorEditor.fields.tooltiptarget',
    ENTITYCREATOREDITOR_FIELDS_MULTIVALUE_LABEL = 'EntityCreatorEditor.fields.multiValue.label',
    ENTITYCREATOREDITOR_FIELDS_MULTIVALUE_HELPTEXT = 'EntityCreatorEditor.fields.multiValue.helpText',
    ENTITYCREATOREDITOR_FIELDS_NEGATABLE_LABEL = 'EntityCreatorEditor.fields.negatable.label',
    ENTITYCREATOREDITOR_FIELDS_NEGATABLE_HELPTEXT = 'EntityCreatorEditor.fields.negatable.helpText',
    ENTITYCREATOREDITOR_PIVOT_EDIT = 'EntityCreatorEditor.pivot.editEntity',
    ENTITYCREATOREDITOR_PIVOT_REQUIREDFOR = 'EntityCreatorEditor.pivot.requiredForActions',
    ENTITYCREATOREDITOR_PIVOT_DISQUALIFIEDACTIONS = 'EntityCreatorEditor.pivot.disqualifiedActions',
    ENTITYCREATOREDITOR_CREATEBUTTON_ARIADESCRIPTION = 'EntityCreatorEditor.createButton.ariaDescription',
    ENTITYCREATOREDITOR_CREATEBUTTON_TEXT = 'EntityCreatorEditor.createButton.text',
    ENTITYCREATOREDITOR_SAVEBUTTON_ARIADESCRIPTION = 'EntityCreatorEditor.saveButton.ariaDescription',
    ENTITYCREATOREDITOR_SAVEBUTTON_TEXT = 'EntityCreatorEditor.saveButton.text',
    ENTITYCREATOREDITOR_CANCELBUTTON_ARIADESCRIPTION = 'EntityCreatorEditor.cancelButton.ariaDescription',
    ENTITYCREATOREDITOR_CANCELBUTTON_TEXT = 'EntityCreatorEditor.cancelButton.text',
    ENTITYCREATOREDITOR_DONEBUTTON_ARIADESCRIPTION = 'EntityCreatorEditor.doneButton.ariaDescription',
    ENTITYCREATOREDITOR_DONEBUTTON_TEXT = 'EntityCreatorEditor.doneButton.text',
    ENTITYCREATOREDITOR_DELETEBUTTON_ARIADESCRIPTION = 'EntityCreatorEditor.deleteButton.ariaDescription',
    ENTITYCREATOREDITOR_DELETEBUTTON_TEXT = 'EntityCreatorEditor.deleteButton.text',
    ENTITYCREATOREDITOR_TRAINDIALOGSBUTTON_ARIADESCRIPTION = 'EntityCreatorEditor.traindialogsButton.ariaDescription',
    ENTITYCREATOREDITOR_TRAINDIALOGSBUTTON_TEXT = 'EntityCreatorEditor.traindialogsButton.text',
    ENTITYCREATOREDITOR_CONFIRM_DELETE_TITLE = 'EntityCreatorEditor.confirmDeleteTitle',
    ENTITYCREATOREDITOR_CONFIRM_DELETE_WARNING = 'EntityCreatorEditor.confirmDeleteWarning',
    ENTITYCREATOREDITOR_CONFIRM_EDIT_TITLE = 'EntityCreatorEditor.confirmEditTitle',
    ENTITYCREATOREDITOR_CONFIRM_EDIT_WARNING = 'EntityCreatorEditor.confirmEditWarning',
    ENTITYCREATOREDITOR_PREBUILT_WARNING = 'EntityCreatorEditor.confirmPrebuiltWarning',
    ENTITYCREATOREDITOR_DELETE_ERROR_TITLE = 'EntityCreatorEditor.deleteErrorTitle',
    ENTITYCREATOREDITOR_DELETE_ERROR_WARNING = 'EntityCreatorEditor.deleteErrorWarning',
    ENTITYCREATOREDITOR_DELETE_ENUM_ERROR_TITLE = 'EntityCreatorEditor.deleteEnumErrorTitle',
    ENTITYCREATOREDITOR_DELETE_ENUM_ERROR_WARNING = 'EntityCreatorEditor.deleteEnumErrorWarning',

    // Error
    ERROR_ERROR = 'Error.error',
    ERROR_WARNING = 'Error.warning',
    ERROR_PRIMARYBUTTON_ARIADESCRIPTION = 'Error.ariaDescription',
    ERROR_PRIMARYBUTTON_TEXT = 'Error.text',
    ERROR_TOOMANYCHARACTERS = 'Error.tooManyChars',

    // ExtractConflictModal
    EXTRACTCONFLICTMODAL_TITLE = 'ExtractConflictModal.title',
    EXTRACTCONFLICTMODAL_SUBTITLE = 'ExtractConflictModal.subtitle',
    EXTRACTCONFLICTMODAL_REVIEW = 'ExtractConflictModal.preview',
    EXTRACTCONFLICTMODAL_CORRECT_LABELS = 'ExtractConflictModal.existing',
    EXTRACTCONFLICTMODAL_CONFLICTING_LABELS = 'ExtractConflictModal.conflictingLabels',
    EXTRACTCONFLICTMODAL_CALLTOACTION = 'ExtractConflictModal.callaction',

    // LogConversionConflictModal
    LOGCONVERSIONCONFLICTMODAL_TITLE = 'LogConversionConflictModal.title',
    LOGCONVERSIONCONFLICTMODAL_SUBTITLE = 'LogConversionConflictModal.subTitle',
    LOGCONVERSIONCONFLICTMODAL_REVIEW = 'LogConversionConflictModal.review',
    LOGCONVERSIONCONFLICTMODAL_BUTTON_EXPLANATION = 'LogConversionConflictModal.buttonExplanation',
    LOGCONVERSIONCONFLICTMODAL_ACCEPT = 'LogConversionConflictModal.accept',
    LOGCONVERSIONCONFLICTMODAL_ABORT = 'LogConversionConflictModal.abort',

    // LogDialogModal
    LOGDIALOGMODAL_DEFAULTBUTTON_ARIADESCRIPTION = 'LogDialogModal.defaultButton.ariaDescription',
    LOGDIALOGMODAL_DEFAULTBUTTON_TEXT = 'LogDialogModal.defaultButton.text',
    LOGDIALOGMODAL_PRIMARYBUTTON_ARIADESCRIPTION = 'LogDialogModal.primaryButton.ariaDescription',
    LOGDIALOGMODAL_PRIMARYBUTTON_TEXT = 'LogDialogModal.primaryButton.text',
    LOGDIALOGMODAL_CONFIRMDELETE_TITLE = 'LogDialogModal.confirmDelete.title',

    // LogDialogs
    LOGDIALOGS_TITLE = 'LogDialogs.title',
    LOGDIALOGS_SUBTITLE = 'LogDialogs.subtitle',
    LOGDIALOGS_CREATEBUTTONTITLE = 'LogDialogs.createButtonTitle',
    LOGDIALOGS_CREATEBUTTONARIALDESCRIPTION = 'LogDialogs.createButtonAriaDescription',
    LOGDIALOGS_MODEL_VERSION = 'LogDialogs.modelVersion',
    LOGDIALOGS_USERINPUT = 'LogDialogs.userInput',
    LOGDIALOGS_TURNS = 'LogDialogs.turns',
    LOGDIALOGS_LOGDISABLED = 'LogDialogs.logdisabled',
    LOGDIALOGS_CREATED_DATE_TIME = 'LogDialogs.createdDateTime',
    LOGDIALOGS_LAST_MODIFIED_DATE_TIME = 'LogDialogs.lastModifiedDateTime',
    LOGDIALOGS_ALREADYSELECTED = 'LogDialogs.alreadySelected',

    // LogDialogAdmin
    LOGDIALOGADMIN_CONFIRMTITLE = 'LogDialogAdmin.confirmTitle',

    // LogOut
    LOGOUT_TITLE = 'LogoutModal.title',
    LOGOUT_PRIMARYBUTTON_ARIADESCRIPTION = 'LogoutModal.primaryButton.ariaDescription',
    LOGOUT_PRIMARYBUTTON_TEXT = 'LogoutModal.primaryButton.text',
    LOGOUT_DEFAULTBUTTON_ARIADESCRIPTION = 'LogoutModal.defaultButton.ariaDescription',
    LOGOUT_DEFAULTBUTTON_TEXT = 'LogoutModal.defaultButton.text',

    // MemoryTable
    MEMORYTABLE_EMPTY = 'MemoryTable.empty',

    // Merge Warning
    MERGE_TITLE = 'Merge.title',
    MERGE_BODY1 = 'Merge.body1',
    MERGE_BODY2 = 'Merge.body2',
    MERGE_BODY3 = 'Merge.body3',
    MERGE_BUTTON_MERGE = 'Merge.button.merge',
    MERGE_BUTTON_SAVE = 'Merge.button.save',
    MERGE_LABEL_MERGED = 'Merge.label.merged',
    MERGE_LABEL_SAVED = 'Merge.label.saved',
    MERGE_LABEL_EQUIVALENT = 'Merge.label.equivalent',

    // PackageCreator
    PACKAGECREATOR_TITLE = 'PackageCreator.title',
    PACKAGECREATOR_TAG_LABEL = 'PackageCreator.tagLabel',
    PACKAGECREATOR_TAG_PLACEHOLDER = 'PackageCreator.tagPlaceholder',
    PACKAGECREATOR_LIVE_LABEL = 'PackageCreator.liveLabel',
    PACKAGECREATOR_CREATEBUTTON_ARIADESCRIPTION = 'PackageCreator.createButton.ariaDescription',
    PACKAGECREATOR_CREATEBUTTON_TEXT = 'PackageCreator.createButton.text',
    PACKAGECREATOR_CANCELBUTTON_ARIADESCRIPTION = 'PackageCreator.cancelButton.ariaDescription',
    PACKAGECREATOR_CANCELBUTTON_TEXT = 'PackageCreator.cancelButton.text',

    // ReplayErrorList
    REPLAYERROR_EXISTS = 'ReplayError.exists',
    REPLAYERROR_EXISTS_LOG = 'ReplayErrorLog.exists',
    REPLAYERROR_WARNING = 'ReplayError.warning',
    REPLAYERROR_LOGDIALOG_VALIDATION_TITLE = 'ReplayError.logdialogvalidation.title',
    REPLAYERROR_LOGDIALOG_VALIDATION_MESSAGE = 'ReplayError.logdialogvalidation.message',
    REPLAYERROR_CONVERT_TITLE = 'ReplayError.logdialogvalidation.convert.title',
    REPLAYERROR_FAILMESSAGE = 'ReplayError.failMessage',
    REPLAYERROR_EDIT_TITLE = 'ReplayError.edit.title',
    REPLAYERROR_BRANCH_TITLE = 'ReplayError.branch.title',
    REPLAYERROR_DESC_ACTION_UNDEFINED = 'ReplayError.Desc.actionUndefined',
    REPLAYERROR_DESC_ACTION_AFTER_WAIT = 'ReplayError.Desc.actionAfterWait',
    REPLAYERROR_DESC_API_BADCARD = 'ReplayError.Desc.apiBadCard',
    REPLAYERROR_DESC_API_EXCEPTION = 'ReplayError.Desc.apiException',
    REPLAYERROR_DESC_API_MALFORMED = 'ReplayError.Desc.apiMalformed',
    REPLAYERROR_DESC_API_UNDEFINED = 'ReplayError.Desc.apiUndefined',
    REPLAYERROR_DESC_INPUT_AFTER_NONWAIT = 'ReplayError.Desc.inputAfterNonWait',
    REPLAYERROR_DESC_ENTITY_UNDEFINED = 'ReplayError.Desc.entityUndefined',
    REPLAYERROR_DESC_ENTITY_EMPTY = 'ReplayError.Desc.entityEmpty',
    REPLAYERROR_DESC_ENTITY_UNEXPECTED_MULTIVALUE = 'ReplayError.Desc.unexpectedMultivalue',
    REPLAYERROR_DESC_TWO_USER_INPUTS = 'ReplayError.Desc.twoUserInputs',
    REPLAYERROR_DESC_ACTION_UNAVAILABLE = 'ReplayError.Desc.actionUnavailable',
    REPLAYERROR_DESC_CHANGED_ENTITIES = 'ReplayError.Desc.changedEntities',
    REPLAYERROR_DESC_EXCEPTION = 'ReplayError.Desc.exception',

    // Settings
    SETTINGS_TITLE = 'Settings.title',
    SETTINGS_SUBTITLE = 'Settings.subtitle',
    SETTINGS_COPYBUTTONARIALDESCRIPTION = 'Settings.copyButtonArielDescription',
    SETTINGS_COPYBUTTONTEXT = 'Settings.copyButtonText',
    SETTINGS_EXPORTBUTTONARIALDESCRIPTION = 'Settings.exportButtonArielDescription',
    SETTINGS_EXPORTBUTTONTEXT = 'Settings.exportButtonText',
    SETTINGS_FIELDERROR_REQUIREDVALUE = 'Settings.fieldError.requiredValue',
    SETTINGS_FIELDERROR_ALPHANUMERIC = 'Settings.fieldError.alphanumeric',
    SETTINGS_FIELDERROR_DISTINCT = 'Settings.fieldError.distinct',
    SETTINGS_FIELDS_NAMELABEL = 'Settings.fields.nameLabel',
    SETTINGS_FILEDS_APPIDLABEL = 'Settings.fields.appIdLabel',
    SETTINGS_FIELDS_MARKDOWNLABEL = 'Settings.fields.markdownLabel',
    SETTINGS_FIELDS_VIDEOLABEL = 'Settings.fields.videoLabel',
    SETTINGS_PASSWORDHIDDEN = 'Settings.passwordHidden',
    SETTINGS_PASSWORDVISIBLE = 'Settings.passwordVisible',
    SETTINGS_BOTFRAMEWORKAPPIDFIELDLABEL = 'Settings.botFrameworkAppIdFieldLabel',
    SETTINGS_BOTFRAMEWORKADDBOTBUTTONTEXT = 'Settings.botFrameworkAddBotButtonText',
    SETTINGS_BOTFRAMEWORKLUISKEY_AUTHORING_LABEL = 'Settings.botFrameworkLuisKey.authoring.label',
    SETTINGS_BOTFRAMEWORKLUISKEY_AUTHORING_PLACEHOLDER = 'Settings.botFrameworkLuisKey.authoring.placeholder',
    SETTINGS_BOTFRAMEWORKLUISKEY_SUBSCRIPTION_LABEL = 'Settings.botFrameworkLuisKey.subscription.label',
    SETTINGS_BOTFRAMEWORKLUISKEY_SUBSCRIPTION_PLACEHOLDER = 'Settings.botFrameworkLuisKey.subscription.placeholder',
    SETTINGS_BOTFRAMEWORKLOCALELABEL = 'Settings.botFrameworkLocaleLabel',
    SETTINGS_BOTFRAMEWORKLISTLABEL = 'Settings.botFrameworkListLabel',
    SETTINGS_SAVECHANGES = 'Settings.saveChanges',
    SETTINGS_DISCARD = 'Settings.discard',
    SETTINGS_LOGGINGON_LABEL = 'Settings.loggingon',
    SETTINGS_DELETEISPERMANENT = 'Settings.deleteIsPermanent',
    SETTINGS_LUIS_LINK = 'Settings.luisLink',
    SETTINGS_MODEL_VERSION_EDITING = 'Settings.modelVersionEditing',
    SETTINGS_MODEL_VERSION_LIVE = 'Settings.modelVersionLive',
    SETTINGS_MODEL_VERSIONS_CREATE = 'Settings.modelVersionsCreate',
    SETTINGS_MODEL_VERSIONS_TITLE = 'Settings.modelVersionsTitle',
    SETTINGS_MODEL_VERSIONS_DESCRIPTION = 'Settings.modelVersionsDescription',

    // Tags and Description
    TAGSINPUT_ADD = 'TagsInput.add',
    TAGSINPUT_ERROR_DUPLICATE = 'TagsInput.error.duplicate',
    TAGSINPUT_READONLY_EMPTY = 'TagsReadOnly.empty',

    // TeachSessionAdmin
    TEACHSESSIONADMIN_DIALOGMODE_USER = 'TeachSessionAdmin.dialogMode.user',
    TEACHSESSIONADMIN_DIALOGMODE_BOT = 'TeachSessionAdmin.dialogMode.bot',
    TEACHSESSIONADMIN_DIALOGMODE_END_SESSION = 'TeachSessionAdmin.dialogMode.endsession',
    TEACHSESSIONADMIN_MEMORY_TITLE = 'TeachSessionAdmin.memory.title',
    TEACHSESSIONADMIN_ENTITYDETECTION_TITLE = 'TeachSessionAdmin.entityDetection.title',
    TEACHSESSIONADMIN_ACTION_TITLE = 'TeachSessionAdmin.action.title',

    // TeachSessionInit
    TEACHSESSIONINIT_INPUT_PLACEHOLDER = 'TeachSessionInit.input.placeholder',
    TEACHSESSIONINIT_TITLE = 'TeachSessionInit.title',

    // TeachSessionModal
    TEACHSESSIONMODAL_TEACH_CONFIRMDELETE_TITLE = 'TeachSessionModal.teach.confirmDelete.title',
    TEACHSESSIONMODAL_EDIT_CONFIRMDELETE_TITLE = 'TeachSessionModal.edit.confirmDelete.title',
    TEACHSESSIONMODAL_INITSTATE_ARIADESCRIPTION = 'TeachSessionModal.initstate.ariaDescription',
    TEACHSESSIONMODAL_INITSTATE_TEXT = 'TeachSessionModal.initstate.text',
    // TextVariation
    TEXTVARIATION_PLACEHOLDER = 'TextVariationCreator.placeholder',

    // ToolTip
    TOOLTIP_ACTION_API = 'ToolTop.ACTION_API',
    TOOLTIP_ACTION_API_TITLE = 'ToolTop.ACTION_API_TITLE',
    TOOLTIP_ACTION_ARGUMENTS = 'ToolTip.ACTION_ARGUMENTS',
    TOOLTIP_ACTION_ARGUMENTS_TITLE = 'ToolTip.ACTION_ARGUMENTS_TITLE',
    TOOLTIP_ACTION_CARD = 'ToolTip.ACTION_CARD',
    TOOLTIP_ACTION_CARD_TITLE = 'ToolTip.ACTION_CARD_TITLE',
    TOOLTIP_ACTION_END_SESSION = 'ToolTip.ACTION_END_SESSION',
    TOOLTIP_ACTION_END_SESSION_TITLE = 'ToolTip.ACTION_CARD_END_SESSION',
    TOOLTIP_ACTION_SET_ENTITY = 'ToolTip.ACTION_SET_ENTITY',
    TOOLTIP_ACTION_SET_ENTITY_TITLE = 'ToolTip.ACTION_SET_ENTITY_TITLE',
    TOOLTIP_ACTION_ENTITY_VALUE = 'ToolTip.ACTION_ENTITY_VALUE',
    TOOLTIP_ACTION_ENTITY_VALUE_TITLE = 'ToolTip.ACTION_ENTITY_VALUE_TITLE',
    TOOLTIP_ACTION_ENTITIES = 'ToolTip.ACTION_ENTITIES',
    TOOLTIP_ACTION_ENTITIES_REQ = 'ToolTip.ACTION_ENTITIES_REQ',
    TOOLTIP_ACTION_ENTITIES_REQ_NOT = 'ToolTip.ACTION_ENTITIES_REQ_NOT',
    TOOLTIP_ACTION_ENTITIES_DISQUAL = 'ToolTip.ACTION_ENTITIES_BLOCK',
    TOOLTIP_ACTION_ENTITIES_DISQUAL_NOT = 'ToolTip.ACTION_ENTITIES_BLOCK_NOT',
    TOOLTIP_ACTION_DISQUAL = 'ToolTip.ACTION_NEGATIVE',
    TOOLTIP_ACTION_DISQUAL_TITLE = 'ToolTip.ACTION_NEGATIVE_TITLE',
    TOOLTIP_ACTION_DISQUAL_ROW1 = 'ToolTip.ACTION_NEGATIVE_TITLE_ROW1',
    TOOLTIP_ACTION_DISQUAL_ROW2 = 'ToolTip.ACTION_NEGATIVE_TITLE_ROW2',
    TOOLTIP_ACTION_DISQUAL_ROW3 = 'ToolTip.ACTION_NEGATIVE_TITLE_ROW3',
    TOOLTIP_ACTION_DISQUAL_ROW4 = 'ToolTip.ACTION_NEGATIVE_TITLE_ROW4',

    TOOLTIP_ACTION_RESPONSE = 'ToolTip.ACTION_RESPONSE',
    TOOLTIP_ACTION_RESPONSE_TEXT1 = 'ToolTip.ACTION_RESPONSE_TEXT1',
    TOOLTIP_ACTION_RESPONSE_TEXT2 = 'ToolTip.ACTION_RESPONSE_TEXT2',
    TOOLTIP_ACTION_RESPONSE_TEXT3 = 'ToolTip.ACTION_RESPONSE_TEXT3',
    TOOLTIP_ACTION_RESPONSE_TEXT_TITLE = 'ToolTip.ACTION_RESPONSE_TEXT_TITLE',
    TOOLTIP_ACTION_RESPONSE_ROW1 = 'ToolTip.ACTION_RESPONSE_ROW1',
    TOOLTIP_ACTION_RESPONSE_ROW2 = 'ToolTip.ACTION_RESPONSE_ROW2',
    TOOLTIP_ACTION_RESPONSE_ROW3 = 'ToolTip.ACTIONRESPONSE_ROW3',

    TOOLTIP_ACTION_REQUIRED = 'ToolTip.ACTION_REQUIRED',
    TOOLTIP_ACTION_REQUIRED_TITLE = 'ToolTip.ACTION_REQUIRED_TITLE',
    TOOLTIP_ACTION_REQUIRED_ROW1 = 'ToolTip.ACTION_REQUIRED_ROW1',
    TOOLTIP_ACTION_REQUIRED_ROW2 = 'ToolTip.ACTION_REQUIRED_ROW2',
    TOOLTIP_ACTION_REQUIRED_ROW3 = 'ToolTip.ACTION_REQUIRED_ROW3',
    TOOLTIP_ACTION_REQUIRED_ROW4 = 'ToolTip.ACTION_REQUIRED_ROW4',
    TOOLTIP_ACTION_SCORE = 'ToolTip.ACTION_SCORE',
    TOOLTIP_ACTION_SCORE_PERCENT = 'ToolTip.ACTION_SCORE_PERCENT',
    TOOLTIP_ACTION_SCORE_TRAINING = 'ToolTip.ACTION_SCORE_TRAINING',
    TOOLTIP_ACTION_SCORE_DISQUALIFIED = 'ToolTip.ACTION_SCORE_DISQUALIFIED',

    TOOLTIP_ACTION_SUGGESTED = 'ToolTip.ACTION_SUGGESTED',
    TOOLTIP_ACTION_SUGGESTED_TITLE = 'ToolTip.ACTION_SUGGESTED_TITLE',
    TOOLTIP_ACTION_SUGGESTED_ROW1 = 'ToolTip.ACTION_SUGGESTED_ROW1',
    TOOLTIP_ACTION_SUGGESTED_ROW2 = 'ToolTip.ACTION_SUGGESTED_ROW2',

    TOOLTIP_ACTION_TYPE = 'ToolTip.ACTION_TYPE',
    TOOLTIP_ACTION_TYPE_TITLE = 'ToolTip.ACTION_TYPE_TITLE',
    TOOLTIP_ACTION_TYPE_TEXT = 'ToolTip.ACTION_TYPE.Text',
    TOOLTIP_ACTION_TYPE_APILOCAL = 'ToolTip.ACTION_TYPE.APILocal',
    TOOLTIP_ACTION_TYPE_ENDSESSION = 'ToolTip.ACTION_TYPE.EndSesion',
    TOOLTIP_ACTION_TYPE_SET_ENTITY = 'ToolTip.ACTION_TYPE.SetEntity',
    TOOLTIP_ACTION_TYPE_CARD = 'ToolTip.ACTION_TYPE.Card',
    TOOLTIP_ACTION_WAIT = 'ToolTip.ACTION_WAIT',
    TOOLTIP_ACTION_WAIT_TITLE = 'ToolTip.ACTION_WAIT_TITLE',

    TOOLTIP_ADD_USER_INPUT_BUTTON = 'ToolTip.ADD_USER_INPUT_BUTTON',
    TOOLTIP_ADD_BOT_RESONSE_BUTTON = 'ToolTip.ADD_BOT_RESPONSE_BUTTON',
    TOOLTIP_BRANCH_BUTTON = 'ToolTip.BRANCH_BUTTON',

    TOOLTIP_BOTINFO_INVALID = 'ToolTip.BOTINFO_INVALID',
    TOOLTIP_ENTITY_ACTION_REQUIRED = 'ToolTip.ENTITY_ACTION_REQUIRED',
    TOOLTIP_ENTITY_ACTION_DISQUALIFIED = 'ToolTip.ENTITY_ACTION_BLOCKED',
    TOOLTIP_ENTITY_EXTRACTOR_HELP = 'ToolTip.ENTITY_EXTRACTOR_HELP',
    TOOLTIP_ENTITY_EXTRACTOR_MATCH_WARNING = 'ToolTip.ENTITY_EXTRACTOR_MATCH_WARNING',
    TOOLTIP_ENTITY_EXTRACTOR_DUPE_WARNING1 = 'ToolTip.ENTITY_EXTRACTOR_DUPE_WARNING1',
    TOOLTIP_ENTITY_EXTRACTOR_DUPE_WARNING2 = 'ToolTip.ENTITY_EXTRACTOR_DUPE_WARNING2',
    TOOLTIP_ENTITY_EXTRACTOR_DLG_SAMETAGGED = 'ToolTip.ENTITY_EXTRACTOR_DIALOG_SameTaggedEntities',
    TOOLTIP_ENTITY_EXTRACTOR_DLG_SAVECHANGES = 'ToolTip.ENTITY_EXTRACTOR_SAVECHANGES',
    TOOLTIP_ENTITY_NAME = 'ToolTip.ENTITY_NAME',
    TOOLTIP_ENTITY_VALUE = 'ToolTip.ENTITY_VALUE',
    TOOLTIP_EXAMPLE = 'ToolTip.EXAMPLE',
    TOOLTIP_LOGGING_TOGGLE = 'ToolTip.LOGGING_TOGGLE',
    TOOLTIP_MEMORYMANAGER = 'ToolTip.ACTION_MEMORYMANAGER',
    TOOLTIP_MEMORYMANAGER_TITLE = 'ToolTip.ACTION_MEMORYMANAGER_TITLE',
    TOOLTIP_MEMORYCONVERTER = 'ToolTip.ACTION_MEMORYCONVERTER',
    TOOLTIP_MEMORYCONVERTER_TITLE = 'ToolTip.ACTION_MEMORYCONVERTER_TITLE',
    TOOLTIP_PACKAGECREATOR_LIVE_TOGGLE = 'ToolTip.PACKAGECREATOR_LIVE_TOGGLE',
    TOOLTIP_REPLAY = 'ToolTop.REPLAY',
    TOOLTIP_TAG_EDITING = 'ToolTip.TAG_EDITING',
    TOOLTIP_TAG_LIVE = 'ToolTip.TAG_LIVE',
    TOOLTIP_TRAINDIALOG_INVALID = 'ToolTip.TRAINDIALOG_INVALID',
    TOOLTIP_TRAINDIALOG_UNKNOWN = 'ToolTip.TOOLTIP_TRAINDIALOG_UNKNOWN',
    TOOLTIP_TRAINDIALOG_WARNING = 'ToolTip.TRAINDIALOG_WARNING',

    // Train Dialogs
    TRAINDIALOGS_TITLE = 'TrainDialogs.title',
    TRAINDIALOGS_SUBTITLE = 'TrainDialogs.subtitle',
    TRAINDIALOGS_CREATEBUTTONTITLE = 'TrainDialogs.createButtonTitle',
    TRAINDIALOGS_CREATEBUTTONARIALDESCRIPTION = 'TrainDialogs.createButtonAriaDescription',
    TRAINDIALOGS_TAGS = 'TrainDialogs.tags',
    TRAINDIALOGS_DESCRIPTION = 'TrainDialogs.description',
    TRAINDIALOGS_TURNS = 'TrainDialogs.turns',
    TRAINDIALOGS_CREATED_DATE_TIME = 'TrainDialogs.createdDateTime',
    TRAINDIALOGS_LAST_MODIFIED_DATE_TIME = 'TrainDialogs.lastModifiedDateTime',
    TRAINDIALOGS_FILTERING_TAGS_LABEL = 'TrainDialogs.FilteringTags.Label',
    TRAINDIALOGS_FILTERING_TAGS = 'TrainDialogs.FilteringTags',
    TRAINDIALOGS_FILTERING_ENTITIES_LABEL = 'TrainDialogs.FilteringEntities.Label',
    TRAINDIALOGS_FILTERING_ENTITIES = 'TrainDialogs.FilteringEntities',
    TRAINDIALOGS_FILTERING_ACTIONS_LABEL = 'TrainDialogs.FilteringActions.Label',
    TRAINDIALOGS_FILTERING_ACTIONS = 'TrainDialogs.FilteringActions',
    TRAINDIALOGS_LISTVIEW_BUTTON = 'TrainDialogs.ListView.Button',
    TRAINDIALOGS_TREEVIEW_BUTTON = 'TrainDialogs.TreeView.Button',

    // TreeView
    TREEVIEW_TOGGLE_FULLSCREEN = 'TreeView.ToggleFullScreen',

    // Tutorial Importer
    TUTORIALIMPORTER_TITLE = 'TutorialImporter.Title',

    // UserInput Modal
    USERINPUT_ADD_TITLE = 'UserInput.addtitle',
    USERINPUT_BRANCH_TITLE = 'UserInput.branchtitle',
    USERINPUT_PLACEHOLDER = 'UserInput.placeholder',

    // Validations
    VALIDATE_UNABLE_TO_EDIT = 'Validate.unableToEdit',
    VALIDATE_UNABLE_TO_BRANCH = 'Validate.unableToBranch',
    VALIDATE_ENTITY_REASON = 'Validate.entityReason',
}

// Message ids follow convention of '<componentname>.<area>[.<subarea>]*`
export default {
    'en-US': {
        //  {FM.ABOUT_TITLE}
        [FM.ABOUT_TITLE]: 'About',
        [FM.DOCS_TITLE]: 'Docs',
        [FM.LOGIN_TITLE]: 'Log In',
        [FM.PROFILE_TITLE]: 'Profile',
        [FM.PROFILE_NAME]: 'Name',
        [FM.PROFILE_SETTINGS_TITLE]: 'Settings',
        [FM.PROFILE_SETTINGS_BOT_PORT]: 'Bot Port',
        [FM.PROFILE_SETTINGS_BOT_PORT_USE_CUSTOM]: 'Use Custom Port',
        [FM.PROFILE_SETTINGS_BOT_PORT_DESCRIPTION]: 'Normally this administrative interface is served from the bot which implies PORT: { port } is also the bot port and it will use this by default. For special cases such as development you can choose to override and use a custom port.',
        [FM.PROFILE_SETTINGS_BOT_PORT_WARNING]: 'Only change this if you know what you are doing.  This value must match the PORT that your bot is listening on.',
        [FM.SUPPORT_TITLE]: 'Support',
        [FM.NOMATCH_TITLE]: 'That page was not found.',
        [FM.NOMATCH_HOME]: 'My Models',
        [FM.PAGE_COMINGSOON]: 'Coming soon...',

        // ActionCreatorEditor
        [FM.ACTIONCREATOREDITOR_SAVEBUTTON_ARIADESCRIPTION]: 'Save',
        [FM.ACTIONCREATOREDITOR_SAVEBUTTON_TEXT]: 'Save',
        [FM.ACTIONCREATOREDITOR_CREATEBUTTON_ARIADESCRIPTION]: 'Create',
        [FM.ACTIONCREATOREDITOR_CREATEBUTTON_TEXT]: 'Create',
        [FM.ACTIONCREATOREDITOR_CANCELBUTTON_ARIADESCRIPTION]: 'Cancel',
        [FM.ACTIONCREATOREDITOR_CANCELBUTTON_TEXT]: 'Cancel',
        [FM.ACTIONCREATOREDITOR_DONEBUTTON_ARIADESCRIPTION]: 'Done',
        [FM.ACTIONCREATOREDITOR_DONEBUTTON_TEXT]: 'Done',
        [FM.ACTIONCREATOREDITOR_DELETEBUTTON_ARIADESCRIPTION]: 'Delete',
        [FM.ACTIONCREATOREDITOR_DELETEBUTTON_TEXT]: 'Delete',
        [FM.ACTIONCREATOREDITOR_TRAINDIALOGSBUTTON_ARIADESCRIPTION]: 'Train Dialogs',
        [FM.ACTIONCREATOREDITOR_TRAINDIALOGSBUTTON_TEXT]: 'Train Dialogs',
        [FM.ACTIONCREATOREDITOR_CONFIRM_DELETE_TITLE]: 'Are you sure you want to delete this Action?',
        [FM.ACTIONCREATOREDITOR_CONFIRM_DELETE_WARNING]: 'This Action is used by one or more Training Dialogs.',
        [FM.ACTIONCREATOREDITOR_CONFIRM_EDIT_TITLE]: 'Are you sure?',
        [FM.ACTIONCREATOREDITOR_CONFIRM_EDIT_WARNING]: 'This edit will invalidate one or more Training Dialogs.  If you proceed they will removed from training until fixed.',
        [FM.ACTIONCREATOREDITOR_CONFIRM_MISSINGLABEL_WARNING]: 'is a plain string not attached to an Entity',
        [FM.ACTIONCREATOREDITOR_WARNING_PAYLOAD]: 'Bot Response is Required',
        [FM.ACTIONCREATOREDITOR_WARNING_ENTITY]: 'Removed reference to undefined Entity',
        [FM.ACTIONCREATOREDITOR_WARNING_NONEMPTYFIELD]: `Non-wait Actions can't have Expected Entities`,
        [FM.ACTIONCREATOREDITOR_WARNING_DUPLICATEACTION]: `Actions must be unique`,
        [FM.ACTIONCREATOREDITOR_WARNING_DUPLICATEFOUND]: 'The action you are creating matches an existing action. Actions must be unique. Please change the properties or close.',
        [FM.ACTIONCREATOREDITOR_WARNING_SET_ENTITY_CREATION]: 'You will not be able to edit this action after saving.',
        [FM.ACTIONCREATOREDITOR_WARNING_SET_ENTITY_EDIT]: 'You cannot save changes to {actionType} Actions.',

        // ActionScorer
        [FM.ACTIONSCORER_COLUMNS_RESPONSE]: 'Response',
        [FM.ACTIONSCORER_COLUMNS_ARGUMENTS]: 'Arguments',
        [FM.ACTIONSCORER_COLUMNS_SCORE]: 'Score',
        [FM.ACTIONSCORER_COLUMNS_ENTITIES]: 'Entities',
        [FM.ACTIONSCORER_COLUMNS_ISTERMINAL]: 'Wait',
        [FM.ACTIONSCORER_COLUMNS_TYPE]: 'Type',
        
        [FM.ACTION_DELETE_INUSE_TITLE]: 'Deleting actions used by train dialogs',
        [FM.ACTION_DELETE_INUSE_PLACEHOLDER_PRESERVE]: 'This operation will preserves the reference to the action leaving a placeholder. All the dialogs using the action will become invalid.  This option can be useful to see where and how the action was used as you correct the dialogs or replace the action.',
        [FM.ACTION_DELETE_INUSE_PLACEHOLDER_REMOVE]: 'This operation will remove the reference to the action. The dialog may become invalid if removal of the action affected memory or left a round unterminated. This option can be useful to if you think most of the dialogs will remain valid and you do not want to have to correct each dialog.',

        // ActionDetailsList
        [FM.ACTIONDETAILSLIST_COLUMNS_RESPONSE]: 'Response',
        [FM.ACTIONDETAILSLIST_COLUMNS_ARGUMENTS]: 'Arguments',
        [FM.ACTIONDETAILSLIST_COLUMNS_TYPE]: 'Action Type',
        [FM.ACTIONDETAILSLIST_COLUMNS_REQUIREDENTITIES]: 'Required Entities',
        [FM.ACTIONDETAILSLIST_COLUMNS_DISQUALIFYINGENTITIES]: 'Disqualifying Entities',
        [FM.ACTIONDETAILSLIST_COLUMNS_SUGGESTEDENTITY]: 'Expected Entity',
        [FM.ACTIONDETAILSLIST_COLUMNS_ISTERMINAL]: 'Wait',

        // Actions
        [FM.ACTIONS_TITLE]: 'Actions',
        [FM.ACTIONS_SUBTITLE]: `Actions are executed by the Bot in response to user input`,
        [FM.ACTIONS_CREATEBUTTONARIADESCRIPTION]: 'Create a New Action',
        [FM.ACTIONS_CREATEBUTTONTITLE]: 'New Action',

        // AppCreator
        [FM.APPCREATOR_FIELDERROR_REQUIREDVALUE]: 'Required Value',
        [FM.APPCREATOR_FIELDERROR_ALPHANUMERIC]: 'Model name may only contain alphanumeric characters',
        [FM.APPCREATOR_FIELDERROR_DISTINCT]: 'Name is already in use.',
        [FM.APPCREATOR_FIELDERROR_TOOLONG]: 'Name length exceeds 30 characters.',
        [FM.APPCREATOR_TITLE]: 'Create a Conversation Learner Model',
        [FM.APPCREATOR_COPY_TITLE]: 'Copy a Conversation Learner Model',
        [FM.APPCREATOR_IMPORT_TITLE]: 'Import a Conversation Learner Model',
        [FM.APPCREATOR_FIELDS_NAME_LABEL]: 'Name',
        [FM.APPCREATOR_FIELDS_IMPORT_NAME_LABEL]: 'New Model Name',
        [FM.APPCREATOR_FIELDS_NAME_PLACEHOLDER]: 'Model name...',
        [FM.APPCREATOR_FIELDS_LOCALE_LABEL]: 'Locale',
        [FM.APPCREATOR_COPYBUTTON_ARIADESCRIPTION]: 'Copy',
        [FM.APPCREATOR_COPYBUTTON_TEXT]: 'Copy',
        [FM.APPCREATOR_CREATEBUTTON_ARIADESCRIPTION]: 'Create',
        [FM.APPCREATOR_CREATEBUTTON_TEXT]: 'Create',
        [FM.APPCREATOR_IMPORT_BUTTON_ARIADESCRIPTION]: 'Import application',
        [FM.APPCREATOR_IMPORT_BUTTON_TEXT]: 'Import',
        [FM.APPCREATOR_CHOOSE_FILE_BUTTON_ARIADESCRIPTION]: 'Locate File',
        [FM.APPCREATOR_CHOOSE_FILE_BUTTON_TEXT]: 'Locate File',
        [FM.APPCREATOR_CANCELBUTTON_ARIADESCRIPTION]: 'Cancel',
        [FM.APPCREATOR_CANCELBUTTON_TEXT]: 'Cancel',

        // App
        [FM.APP_HEADER_MODELS]: 'My Models',
        [FM.APP_HEADER_ABOUT]: 'About',
        [FM.APP_HEADER_DOCS]: 'Docs',
        [FM.APP_HEADER_SUPPORT]: 'Support',

        // Model Metadata
        [FM.APP_VERSION]: 'Version:',

        // TrainingStatus
        [FM.APP_TRAINING_STATUS_STATUS]: 'Training',
        [FM.APP_TRAINING_STATUS_UNKNOWN]: 'Unknown',
        [FM.APP_TRAINING_STATUS_QUEUED]: 'Queued',
        [FM.APP_TRAINING_STATUS_RUNNING]: 'Running',
        [FM.APP_TRAINING_STATUS_COMPLETED]: 'Completed',
        [FM.APP_TRAINING_STATUS_FAILED]: 'Failed',
        [FM.APP_TRAINING_STATUS_LAST_UPDATE]: 'Last Updated',
        [FM.APP_TRAINING_STATUS_REFRESH]: 'Refresh',
        [FM.APP_TRAINING_STATUS_EXPIRED]: 'Polling was stopped before training status was finalized. Please Refresh',

        // Apps List
        [FM.APPSLIST_SUBTITLE]: 'Create and manage your Conversation Learner models',
        [FM.APPSLIST_CREATEBUTTONARIADESCRIPTION]: 'Create a New Model',
        [FM.APPSLIST_CREATEBUTTONTEXT]: 'New Model',
        [FM.APPSLIST_EMPTY_TEXT]: 'Create a New Model',
        [FM.APPSLIST_IMPORTAPP_BUTTONARIADESCRIPTION]: 'Import Model',
        [FM.APPSLIST_IMPORTAPP_BUTTONTEXT]: 'Import Model',
        [FM.APPSLIST_IMPORTTUTORIALS_BUTTONARIADESCRIPTION]: 'Import Tutorials Models',
        [FM.APPSLIST_IMPORTTUTORIALS_BUTTONTEXT]: 'Import Tutorials',
        [FM.APPSLIST_CONFIRMCANCELMODALTITLE]: `Confirm the deletion by entering the Model's name`,
        [FM.APPSLIST_COLUMN_NAME]: 'Name',
        [FM.APPSLIST_COLUMNS_LOCALE]: 'Locale',
        [FM.APPSLIST_COLUMNS_LINKEDBOTS]: 'Linked Bots',
        [FM.APPSLIST_COLUMNS_CREATED_DATE_TIME]: 'Created',
        [FM.APPSLIST_COLUMNS_LAST_MODIFIED_DATE_TIME]: 'Last Modified',
        [FM.APPSLIST_COLUMNS_LOGGING]: 'Logging Enabled',
        [FM.APPSLIST_COLUMNS_ACTIONS]: 'Actions',

        // Generic Buttons
        [FM.BUTTON_ABANDON]: 'Abandon',
        [FM.BUTTON_ABANDON_BRANCH]: 'Abandon Branch',
        [FM.BUTTON_ABANDON_EDIT]: 'Abandon Edit',
        [FM.BUTTON_ACCEPT]: 'Accept',
        [FM.BUTTON_CANCEL]: 'Cancel',
        [FM.BUTTON_CLOSE]: 'Close',
        [FM.BUTTON_DELETE]: 'Delete',
        [FM.BUTTON_IMPORT]: 'Import',
        [FM.BUTTON_INFO]: 'Info',
        [FM.BUTTON_OK]: 'OK',
        [FM.BUTTON_REPLAY]: 'Replay',
        [FM.BUTTON_SAVE]: 'Save',
        [FM.BUTTON_SAVE_AS_TRAIN_DIALOG]: 'Save As Train Dialog',
        [FM.BUTTON_SAVE_BRANCH]: 'Save Branch',
        [FM.BUTTON_SAVE_EDIT]: 'Save Edit',
        [FM.BUTTON_SUBMIT]: 'Submit',
        [FM.BUTTON_UNDO]: 'Undo',
        [FM.BUTTON_SELECT]: 'Select',
        [FM.BUTTON_SELECTED]: 'Selected',
        [FM.BUTTON_NEXT]: 'Next',
        [FM.BUTTON_PREVIOUS]: 'Previous',

        // Error Messages
        [FM.CUSTOMERROR_NETWORK_ERROR]: 'Is your Bot running? Did you set NODE_ENV=development?',

        // Dashboard
        [FM.DASHBOARD_TITLE]: 'Overview',
        [FM.DASHBOARD_SUBTITLE]: `Notifications about this model`,

        // Entities
        [FM.ENTITIES_TITLE]: 'Entities',
        [FM.ENTITIES_SUBTITLE]: `Entities hold values that are extracted from user utterances or set by code. They are stored in the Bot's memory to track state`,
        [FM.ENTITIES_CREATEBUTTONARIALDESCRIPTION]: 'Create a New Entity',
        [FM.ENTITIES_CREATEBUTTONTEXT]: 'New Entity',
        [FM.ENTITIES_COLUMNS_NAME]: 'Name',
        [FM.ENTITIES_COLUMNS_TYPE]: 'Type',
        [FM.ENTITIES_COLUMNS_RESOLVER]: 'Resolver Type',
        [FM.ENTITIES_COLUMNS_IS_PROGRAMMATIC]: 'Programmatic',
        [FM.ENTITIES_COLUMNS_IS_BUCKETABLE]: 'Multi-Value',
        [FM.ENTITIES_COLUMNS_IS_NEGATABLE]: 'Negatable',
        [FM.ENTITIES_COLUMNS_CREATED_DATE_TIME]: 'Created',
        [FM.ENTITIES_CONFIRMCANCELMODALTITLE]: 'Are you sure you want to delete this entity?',

        // LogDialogs
        [FM.LOGDIALOGS_TITLE]: 'Log Dialogs',
        [FM.LOGDIALOGS_SUBTITLE]: 'Log Dialogs are records of conversations between users and your Bot. You can make corrections to Log Dialogs to improve the Bot.',
        [FM.LOGDIALOGS_CREATEBUTTONTITLE]: 'New Log Dialog',
        [FM.LOGDIALOGS_CREATEBUTTONARIALDESCRIPTION]: 'Create a New Log Dialog',
        [FM.LOGDIALOGS_MODEL_VERSION]: 'Model Version',
        [FM.LOGDIALOGS_USERINPUT]: 'User Input',
        [FM.LOGDIALOGS_TURNS]: 'Turns',
        [FM.LOGDIALOGS_LOGDISABLED]: 'Logging is disabled',
        [FM.LOGDIALOGS_CREATED_DATE_TIME]: 'Created',
        [FM.LOGDIALOGS_LAST_MODIFIED_DATE_TIME]: 'Last Modified',
        [FM.LOGDIALOGS_ALREADYSELECTED]: 'Action already selected',

        // LogDialogAdmin
        [FM.LOGDIALOGADMIN_CONFIRMTITLE]: 'This will attempt to replay the Log Dialog against the Bot and convert it into a new Train Dialog',

        // ReplayErrorList
        [FM.REPLAYERROR_EXISTS]: 'This Train Dialog has errors that must be fixed before it can be used to train your model',
        [FM.REPLAYERROR_EXISTS_LOG]: 'This Log Dialog has errors that must be fixed before it can be converted to a Train Dialog',
        [FM.REPLAYERROR_WARNING]: 'This Train Dialog has some potential errors',
        [FM.REPLAYERROR_LOGDIALOG_VALIDATION_TITLE]: 'Model definition has changed',
        [FM.REPLAYERROR_LOGDIALOG_VALIDATION_MESSAGE]: 'This Log Dialog was created with a earlier version of the model.  The following incompatibilities were found:',
        [FM.REPLAYERROR_CONVERT_TITLE]: 'Unable to convert to Train Dialog',
        [FM.REPLAYERROR_FAILMESSAGE]: 'The following issues need to be corrected first',
        [FM.REPLAYERROR_EDIT_TITLE]: 'Unable to continue Dialog',
        [FM.REPLAYERROR_BRANCH_TITLE]: 'Unable to Branch',
        [FM.REPLAYERROR_DESC_ACTION_AFTER_WAIT]: 'Action follows a Wait Action',
        [FM.REPLAYERROR_DESC_ACTION_UNDEFINED]: 'Action does not exist',
        [FM.REPLAYERROR_DESC_API_BADCARD]: 'API Render function returned a malformed Activity',
        [FM.REPLAYERROR_DESC_API_EXCEPTION]: 'API in Bot encountered an exception',
        [FM.REPLAYERROR_DESC_API_MALFORMED]: 'Logic portion of callback returns a value, but no Render portion defined',
        [FM.REPLAYERROR_DESC_API_UNDEFINED]: 'API does not exist on running Bot',
        [FM.REPLAYERROR_DESC_INPUT_AFTER_NONWAIT]: 'User Input following a non-Wait Action',
        [FM.REPLAYERROR_DESC_ENTITY_UNDEFINED]: 'Entity does not exist',
        [FM.REPLAYERROR_DESC_ENTITY_EMPTY]: 'Action missing a value for',
        [FM.REPLAYERROR_DESC_ENTITY_UNEXPECTED_MULTIVALUE]: 'Non-multivalue Entity labeled with more than one value',
        [FM.REPLAYERROR_DESC_TWO_USER_INPUTS]: 'Two consecutive User Inputs',
        [FM.REPLAYERROR_DESC_ACTION_UNAVAILABLE]: 'Action is unavailable',
        [FM.REPLAYERROR_DESC_CHANGED_ENTITIES]: 'Entities inconsistent after user input',
        [FM.REPLAYERROR_DESC_EXCEPTION]: `Encountered an error in Bot's API callback`,

        // Settings
        [FM.SETTINGS_TITLE]: 'Settings',
        [FM.SETTINGS_SUBTITLE]: 'Control your model version tags and other model configuration',
        [FM.SETTINGS_COPYBUTTONARIALDESCRIPTION]: 'Copy Model',
        [FM.SETTINGS_COPYBUTTONTEXT]: 'Copy',
        [FM.SETTINGS_EXPORTBUTTONARIALDESCRIPTION]: 'Export Model to File',
        [FM.SETTINGS_EXPORTBUTTONTEXT]: 'Export',
        [FM.SETTINGS_FIELDERROR_REQUIREDVALUE]: 'Required Value',
        [FM.SETTINGS_FIELDERROR_ALPHANUMERIC]: 'Model names may only contain alphanumeric characters',
        [FM.SETTINGS_FIELDERROR_DISTINCT]: 'Name is already in use.',
        [FM.SETTINGS_FIELDS_NAMELABEL]: 'Name',
        [FM.SETTINGS_FILEDS_APPIDLABEL]: 'Model ID',
        [FM.SETTINGS_FIELDS_MARKDOWNLABEL]: 'Markdown',
        [FM.SETTINGS_FIELDS_VIDEOLABEL]: 'Video',
        [FM.SETTINGS_PASSWORDHIDDEN]: 'Show',
        [FM.SETTINGS_PASSWORDVISIBLE]: 'Hide',
        [FM.SETTINGS_BOTFRAMEWORKAPPIDFIELDLABEL]: 'Model ID',
        [FM.SETTINGS_BOTFRAMEWORKADDBOTBUTTONTEXT]: 'Add',
        [FM.SETTINGS_BOTFRAMEWORKLUISKEY_AUTHORING_LABEL]: 'LUIS Authoring Key',
        [FM.SETTINGS_BOTFRAMEWORKLUISKEY_AUTHORING_PLACEHOLDER]: 'Authoring Key...',
        [FM.SETTINGS_BOTFRAMEWORKLUISKEY_SUBSCRIPTION_LABEL]: 'LUIS Subscription Key',
        [FM.SETTINGS_BOTFRAMEWORKLUISKEY_SUBSCRIPTION_PLACEHOLDER]: 'Subscription Key...',
        [FM.SETTINGS_BOTFRAMEWORKLOCALELABEL]: 'Locale',
        [FM.SETTINGS_BOTFRAMEWORKLISTLABEL]: 'Bot Framework Apps',
        [FM.SETTINGS_SAVECHANGES]: 'Save Changes',
        [FM.SETTINGS_DISCARD]: 'Discard',
        [FM.SETTINGS_LOGGINGON_LABEL]: 'Log Conversations',
        [FM.SETTINGS_DELETEISPERMANENT]: 'Deletion is irreversible.',
        [FM.SETTINGS_LUIS_LINK]: 'Go to LUIS',
        [FM.SETTINGS_MODEL_VERSION_EDITING]: 'Displayed Version',
        [FM.SETTINGS_MODEL_VERSION_LIVE]: 'Live Version',
        [FM.SETTINGS_MODEL_VERSIONS_CREATE]: 'New Version',
        [FM.SETTINGS_MODEL_VERSIONS_TITLE]: 'Model Versions',
        [FM.SETTINGS_MODEL_VERSIONS_DESCRIPTION]: 'Creating a new version will save a snapshot of the currently active model. You can promote this version to "live" for use in deployed bots while you continue to edit the latest version.  You can also recall these snapshots at any point in time.',

        // ToolTip
        [FM.TOOLTIP_ACTION_API]: 'APIs exposed in the running Bot of the form:',
        [FM.TOOLTIP_ACTION_API_TITLE]: 'API',
        [FM.TOOLTIP_ACTION_ARGUMENTS]: `When Action Type is an API call, a list of comma separated arguments passed to the API. Arguments prefixed with a $ refer to Entity values.  For example: "$city"`,
        [FM.TOOLTIP_ACTION_ARGUMENTS_TITLE]: `Arguments`,
        [FM.TOOLTIP_ACTION_CARD]: `When Action Type is a card call, a list of comma separated arguments passed to the Card. Arguments prefixed with a $ refer to Entity values.  For example: "$city"`,
        [FM.TOOLTIP_ACTION_CARD_TITLE]: `Card`,
        [FM.TOOLTIP_ACTION_END_SESSION]: `Data to send to "onSessionEndCallback" when this Action is selected`,
        [FM.TOOLTIP_ACTION_END_SESSION_TITLE]: `End Session`,
        [FM.TOOLTIP_ACTION_SET_ENTITY]: `Since these are actions they can be learned just like any other action in your bot.`,
        [FM.TOOLTIP_ACTION_SET_ENTITY_TITLE]: `Set Entity`,
        [FM.TOOLTIP_ACTION_ENTITY_VALUE]: `When this action is taken by the bot it will result in the entity being set with this value`,
        [FM.TOOLTIP_ACTION_ENTITY_VALUE_TITLE]: `Entity Value`,
        [FM.TOOLTIP_ACTION_ENTITIES]: 'Status of Entity requirements for this Action:',
        [FM.TOOLTIP_ACTION_ENTITIES_REQ]: 'Required Entity is present',
        [FM.TOOLTIP_ACTION_ENTITIES_REQ_NOT]: 'Required Enitity is missing (DISQUALIFIES ACTION)',
        [FM.TOOLTIP_ACTION_ENTITIES_DISQUAL]: 'Disqualifying Entity is present (DISQUALIFIES ACTION)',
        [FM.TOOLTIP_ACTION_ENTITIES_DISQUAL_NOT]: 'Disqualifying Entity is missing',

        [FM.TOOLTIP_ACTION_DISQUAL]: 'Action will not be selected if Memory already contains value for these Entities',
        [FM.TOOLTIP_ACTION_DISQUAL_TITLE]: 'Disqualifying Entities',
        [FM.TOOLTIP_ACTION_DISQUAL_ROW1]: '"How would you like to pay?"',
        [FM.TOOLTIP_ACTION_DISQUAL_ROW2]: '$paymentDetails',
        [FM.TOOLTIP_ACTION_DISQUAL_ROW3]: '"When were you born?"',
        [FM.TOOLTIP_ACTION_DISQUAL_ROW4]: '$birthdate',

        [FM.TOOLTIP_ACTION_RESPONSE]: 'Value of Response that Bot will take',
        [FM.TOOLTIP_ACTION_RESPONSE_TEXT1]: 'Text the Bot will display to the user.',
        [FM.TOOLTIP_ACTION_RESPONSE_TEXT2]: 'Prefix text with a $ to substitute Entity values.',
        [FM.TOOLTIP_ACTION_RESPONSE_TEXT3]: 'Text contained in brackets (i.e. []) will only be displayed if all contained entities have values.',
        [FM.TOOLTIP_ACTION_RESPONSE_TEXT_TITLE]: 'Response',
        [FM.TOOLTIP_ACTION_RESPONSE_ROW1]: '"How can I help you?"',
        [FM.TOOLTIP_ACTION_RESPONSE_ROW2]: '"You have $toppings on your pizza."',
        [FM.TOOLTIP_ACTION_RESPONSE_ROW3]: '"Hi[, $name]"',

        [FM.TOOLTIP_ACTION_REQUIRED]: 'Action will not be selected unless Memory contains values for these Entities',
        [FM.TOOLTIP_ACTION_REQUIRED_TITLE]: 'Required Entities',
        [FM.TOOLTIP_ACTION_REQUIRED_ROW1]: '"How would you like to pay?"',
        [FM.TOOLTIP_ACTION_REQUIRED_ROW2]: '$orderDetails $address',
        [FM.TOOLTIP_ACTION_REQUIRED_ROW3]: '"Hi, $name"',
        [FM.TOOLTIP_ACTION_REQUIRED_ROW4]: '$name',

        [FM.TOOLTIP_ACTION_SCORE]: 'Score:',
        [FM.TOOLTIP_ACTION_SCORE_PERCENT]: 'Conversation Learner confidence in performing an Action',
        [FM.TOOLTIP_ACTION_SCORE_TRAINING]: `Action can't be scored yet as Conversation Learner is still training`,
        [FM.TOOLTIP_ACTION_SCORE_DISQUALIFIED]: 'Action has been disqualified - Required Entities are missing or Blocked Entities are present',

        [FM.TOOLTIP_ACTION_SUGGESTED]: `Hint to Conversation Learner that the user's reply to this Action will likely be a value for this Entity. Pre-Trained Entities cannot be used as Expected Entities.`,
        [FM.TOOLTIP_ACTION_SUGGESTED_TITLE]: 'Expected Response',
        [FM.TOOLTIP_ACTION_SUGGESTED_ROW1]: '"What is your name?"',
        [FM.TOOLTIP_ACTION_SUGGESTED_ROW2]: '$name',

        [FM.TOOLTIP_ACTION_TYPE]: 'One of the following:',
        [FM.TOOLTIP_ACTION_TYPE_TITLE]: 'Action Type',
        [FM.TOOLTIP_ACTION_TYPE_TEXT]: 'A text response',
        [FM.TOOLTIP_ACTION_TYPE_APILOCAL]: 'An API call to the Bot',
        [FM.TOOLTIP_ACTION_TYPE_ENDSESSION]: 'Indicate Bot is done',
        [FM.TOOLTIP_ACTION_TYPE_SET_ENTITY]: 'Set an entity to a known enum value',
        [FM.TOOLTIP_ACTION_TYPE_CARD]: 'Renders an Adaptive Card template',
        [FM.TOOLTIP_ACTION_WAIT]: 'When selected, Bot will wait for more user input before taking another Action',
        [FM.TOOLTIP_ACTION_WAIT_TITLE]: 'Wait For Response',

        [FM.TOOLTIP_ADD_USER_INPUT_BUTTON]: 'Add a new user input',
        [FM.TOOLTIP_ADD_BOT_RESONSE_BUTTON]: 'Add a new Bot response',
        [FM.TOOLTIP_BRANCH_BUTTON]: 'Create a new Train Dialog by branching at this step',

        [FM.TOOLTIP_BOTINFO_INVALID]: 'This model contains Card or API references that do not exist in the running Bot',
        [FM.TOOLTIP_ENTITY_ACTION_DISQUALIFIED]: `Actions that are blocked from use if this Entity is set`,
        [FM.TOOLTIP_ENTITY_ACTION_REQUIRED]: `Actions that are only employed when this Entity is set`,
        [FM.TOOLTIP_ENTITY_EXTRACTOR_HELP]: `Select text to label it as an entity`,
        [FM.TOOLTIP_ENTITY_EXTRACTOR_MATCH_WARNING]: 'Equivalent input must contain the same detected Entities as the original input text.',
        [FM.TOOLTIP_ENTITY_EXTRACTOR_DUPE_WARNING1]: 'Entities that are not multi-value (i.e. ',
        [FM.TOOLTIP_ENTITY_EXTRACTOR_DUPE_WARNING2]: ') will only store the last labelled utterance',
        [FM.TOOLTIP_ENTITY_EXTRACTOR_DLG_SAMETAGGED]: 'Equivalent input must all have same tagged entities.',
        [FM.TOOLTIP_ENTITY_EXTRACTOR_DLG_SAVECHANGES]: 'Do you want to save your Entity Detection changes?',

        [FM.TOOLTIP_ENTITY_NAME]: 'Name of the Entity',
        [FM.TOOLTIP_ENTITY_VALUE]: 'What the Bot currently has in Memory for this Entity',
        [FM.TOOLTIP_EXAMPLE]: 'For example:',
        [FM.TOOLTIP_LOGGING_TOGGLE]: 'Enables or disables logging of user conversations. When logging is enabled, Bot performance can be improved by providing corrections to Logs that contain undesired Bot responses.  The corrected Log Dialogs become new Training Dialogs',
        [FM.TOOLTIP_MEMORYMANAGER]: `The memory manager provides the following functions for manipulating the Bot's memory:`,
        [FM.TOOLTIP_MEMORYMANAGER_TITLE]: 'Memory Manager',
        [FM.TOOLTIP_MEMORYCONVERTER]: `Conversation Learner provides the following converters, but developers are free to write additional ones:`,
        [FM.TOOLTIP_MEMORYCONVERTER_TITLE]: 'Memory Converters',
        [FM.TOOLTIP_PACKAGECREATOR_LIVE_TOGGLE]: 'When checked the new Tag will become the Live app served to users',
        [FM.TOOLTIP_REPLAY]: `Replay each step in the Dialog, calling the EntityDetectionCallback and any API callbacks.  This will update the Dialog to reflect any changes made to the Bot's APIs`,
        [FM.TOOLTIP_TAG_EDITING]: 'The version of the Model displayed in this administrative interface. You can view any version but can only edit the "Master" version.',
        [FM.TOOLTIP_TAG_LIVE]: 'The version of the Model used when published to external channels (e.g. Skype)',
        [FM.TOOLTIP_TRAINDIALOG_INVALID]: 'This Model contains Train Dialogs that have been invalided.  They must be edited and fixed to be included in training',
        [FM.TOOLTIP_TRAINDIALOG_UNKNOWN]: 'This Model contains Train Dialogs that may have errors. They must be replayed and any errors fixed to be included in training',
        [FM.TOOLTIP_TRAINDIALOG_WARNING]: 'This Model contains Train Dialogs that may have errors.',

        // Train Dialogs
        [FM.TRAINDIALOGS_TITLE]: 'Train Dialogs',
        [FM.TRAINDIALOGS_SUBTITLE]: 'Train Dialogs are example conversations you want your Bot to imitate',
        [FM.TRAINDIALOGS_CREATEBUTTONTITLE]: 'New Train Dialog',
        [FM.TRAINDIALOGS_CREATEBUTTONARIALDESCRIPTION]: 'Create a New Train Dialog',
        [FM.TRAINDIALOGS_TAGS]: 'Tags',
        [FM.TRAINDIALOGS_DESCRIPTION]: 'Description',
        [FM.TRAINDIALOGS_TURNS]: 'Turns',
        [FM.TRAINDIALOGS_CREATED_DATE_TIME]: 'Created',
        [FM.TRAINDIALOGS_LAST_MODIFIED_DATE_TIME]: 'Last Modified',
        [FM.TRAINDIALOGS_FILTERING_TAGS_LABEL]: 'Filter by Tag:',
        [FM.TRAINDIALOGS_FILTERING_TAGS]: 'All tags',
        [FM.TRAINDIALOGS_FILTERING_ENTITIES_LABEL]: 'Filter by Entity:',
        [FM.TRAINDIALOGS_FILTERING_ENTITIES]: 'All entities',
        [FM.TRAINDIALOGS_FILTERING_ACTIONS_LABEL]: 'Filter by Actions:',
        [FM.TRAINDIALOGS_FILTERING_ACTIONS]: 'All actions',
        [FM.TRAINDIALOGS_LISTVIEW_BUTTON]: 'List View',
        [FM.TRAINDIALOGS_TREEVIEW_BUTTON]: 'Tree View',

        // TreeView
        [FM.TREEVIEW_TOGGLE_FULLSCREEN]: 'Toggle Fullscreen',

        // Tutorial Importer
        [FM.TUTORIALIMPORTER_TITLE]: 'Tutorials',

        // Validation
        [FM.VALIDATE_UNABLE_TO_EDIT]: 'Unable to Edit',
        [FM.VALIDATE_UNABLE_TO_BRANCH]: 'Unable to Branch',
        [FM.VALIDATE_ENTITY_REASON]: 'Bot API calls are behaving differently. Entities in memory do not match.',

        // ActionDetailsList
        [FM.ACTIONDETAILSLIST_COLUMNS_RESPONSE]: 'Response',
        [FM.ACTIONDETAILSLIST_COLUMNS_ARGUMENTS]: 'Arguments',
        [FM.ACTIONDETAILSLIST_COLUMNS_TYPE]: 'Action Type',
        [FM.ACTIONDETAILSLIST_COLUMNS_REQUIREDENTITIES]: 'Required Entities',
        [FM.ACTIONDETAILSLIST_COLUMNS_DISQUALIFYINGENTITIES]: 'Disqualifying Entities',
        [FM.ACTIONDETAILSLIST_COLUMNS_SUGGESTEDENTITY]: 'Expected Entity',
        [FM.ACTIONDETAILSLIST_COLUMNS_ISTERMINAL]: 'Wait',
        [FM.ACTIONDETAILSLIST_COLUMNS_CREATED_DATE_TIME]: 'Created',

        // TextVariationCreator
        [FM.TEXTVARIATION_PLACEHOLDER]: 'Add alternative input...',
        [FM.BUTTON_INFO]: 'Info',

        // DemoImporter
        [FM.DEMOIMPORT_TITLE]: 'Import Demo Models',
        [FM.DEMOIMPORT_BUTTON_ARIADESCRIPTION]: 'Import Demo Models',
        [FM.DEMOIMPORT_BUTTON_TEXT]: 'Import',

        // ChatSessionModal
        [FM.CHATSESSIONMODAL_PRIMARYBUTTON_ARIADESCRIPTION]: 'Done Testing',
        [FM.CHATSESSIONMODAL_PRIMARYBUTTON_TEXT]: 'Done Testing',
        [FM.CHATSESSIONMODAL_EXPIREBUTTON_ARIADESCRIPTION]: 'Session Timeout',
        [FM.CHATSESSIONMODAL_EXPIREBUTTON_TEXT]: 'Session Timeout',
        [FM.CHATSESSIONMODAL_TIMEOUT_TITLE]: 'The EndSession callback will be invoked on the next user input, and a new Session started',

        // ConfirmCancelModal
        [FM.CONFIRMCANCELMODAL_PRIMARYBUTTON_TEXT]: 'Confirm',
        [FM.CONFIRMCANCELMODAL_DEFAULTBUTTON_TEXT]: 'Cancel',

        // DialogMetadata
        [FM.DIALOGMETADATA_TAGS_LABEL]: 'Tags',
        [FM.DIALOGMETADATA_DESCRIPTION_LABEL]: 'Description',
        [FM.DIALOGMETADATA_DESCRIPTION_PLACEHOLDER]: 'Click to add description',
        [FM.DIALOGMETADATA_USERINPUT_LABEL]: 'User Input',
        [FM.DIALOGMETADATA_ALTINPUT_LABEL]: 'Alt Input',

        // EntityCreatorEditor
        [FM.ENTITYCREATOREDITOR_FIELDERROR_NOBLANK]: 'May not be blank',
        [FM.ENTITYCREATOREDITOR_FIELDERROR_REQUIREDVALUE]: 'Required Value',
        [FM.ENTITYCREATOREDITOR_FIELDERROR_MAX_LENGTH]: 'May not exceed 30 characters.',
        [FM.ENTITYCREATOREDITOR_FIELDERROR_ALPHANUMERIC]: 'May only contain alphanumeric characters with no spaces.',
        [FM.ENTITYCREATOREDITOR_FIELDERROR_DISTINCT]: 'Name is already in use.',
        [FM.ENTITYCREATOREDITOR_FIELDERROR_RESERVED]: 'Name is reserved.',
        [FM.ENTITYCREATOREDITOR_ENTITYOPTION_ENUM]: 'Enum',
        [FM.ENTITYCREATOREDITOR_ENTITYOPTION_LUIS]: 'Custom Trained',
        [FM.ENTITYCREATOREDITOR_ENTITYOPTION_PROG]: 'Programmatic',
        [FM.ENTITYCREATOREDITOR_ENTITY_RESOLVEROPTION_NONE]: 'none',
        [FM.ENTITYCREATOREDITOR_TITLE_CREATE]: 'Create an Entity',
        [FM.ENTITYCREATOREDITOR_TITLE_EDIT]: 'Edit Entity',
        [FM.ENTITYCREATOREDITOR_FIELDS_ENUM_LABEL]: 'Enum Values:',
        [FM.ENTITYCREATOREDITOR_FIELDS_NAME_LABEL]: 'Entity Name',
        [FM.ENTITYCREATOREDITOR_FIELDS_NAME_PLACEHOLDER]: 'Name...',
        [FM.ENTITYCREATOREDITOR_FIELDS_TYPE_LABEL]: 'Entity Type',
        [FM.ENTITYCREATOREDITOR_FIELDS_RESOLVER_LABEL]: 'Resolver Type',
        [FM.ENTITYCREATOREDITOR_FIELDS_PROGRAMMATICONLY_LABEL]: 'Programmatic Only',
        [FM.ENTITYCREATOREDITOR_FIELDS_MULTIVALUE_LABEL]: 'Multi-valued',
        [FM.ENTITYCREATOREDITOR_FIELDS_NEGATABLE_LABEL]: 'Negatable',
        [FM.ENTITYCREATOREDITOR_PIVOT_EDIT]: 'Edit Entity',
        [FM.ENTITYCREATOREDITOR_PIVOT_REQUIREDFOR]: 'Required For Actions',
        [FM.ENTITYCREATOREDITOR_PIVOT_DISQUALIFIEDACTIONS]: 'Blocked Actions',
        [FM.ENTITYCREATOREDITOR_CREATEBUTTON_ARIADESCRIPTION]: 'Create',
        [FM.ENTITYCREATOREDITOR_CREATEBUTTON_TEXT]: 'Create',
        [FM.ENTITYCREATOREDITOR_SAVEBUTTON_ARIADESCRIPTION]: 'Save',
        [FM.ENTITYCREATOREDITOR_SAVEBUTTON_TEXT]: 'Save',
        [FM.ENTITYCREATOREDITOR_CANCELBUTTON_ARIADESCRIPTION]: 'Cancel',
        [FM.ENTITYCREATOREDITOR_CANCELBUTTON_TEXT]: 'Cancel',
        [FM.ENTITYCREATOREDITOR_DONEBUTTON_ARIADESCRIPTION]: 'Done',
        [FM.ENTITYCREATOREDITOR_DONEBUTTON_TEXT]: 'Done',
        [FM.ENTITYCREATOREDITOR_DELETEBUTTON_ARIADESCRIPTION]: 'Delete',
        [FM.ENTITYCREATOREDITOR_DELETEBUTTON_TEXT]: 'Delete',
        [FM.ENTITYCREATOREDITOR_TRAINDIALOGSBUTTON_ARIADESCRIPTION]: 'Train Dialogs',
        [FM.ENTITYCREATOREDITOR_TRAINDIALOGSBUTTON_TEXT]: 'Train Dialogs',
        [FM.ENTITYCREATOREDITOR_CONFIRM_DELETE_TITLE]: 'Are you sure you want to delete this Entity?',
        [FM.ENTITYCREATOREDITOR_CONFIRM_DELETE_WARNING]: 'This Entity is used by one or more Actions or Training Dialogs.  If you proceed it will also be removed from these Actions and Training Dialogs.',
        [FM.ENTITYCREATOREDITOR_CONFIRM_EDIT_TITLE]: 'Are you sure you want to edit this Entity?',
        [FM.ENTITYCREATOREDITOR_CONFIRM_EDIT_WARNING]: 'This edit may invalidate one or more Training Dialogs.  If you proceed they may be removed from training until fixed.',
        [FM.ENTITYCREATOREDITOR_PREBUILT_WARNING]: 'Note: You must wait for training to complete before the new pre-trained Entity will be detected',
        [FM.ENTITYCREATOREDITOR_DELETE_ERROR_TITLE]: 'Unable to delete this Entity',
        [FM.ENTITYCREATOREDITOR_DELETE_ERROR_WARNING]: 'It is either referenced within the payload, used as suggested entity, or used to set an entity by one or more Actions',
        [FM.ENTITYCREATOREDITOR_DELETE_ENUM_ERROR_TITLE]: 'Are you sure?',
        [FM.ENTITYCREATOREDITOR_DELETE_ENUM_ERROR_WARNING]: 'Enum is referenced by one or more Actions and may invalidate related Training Dialogs',

        // Error
        [FM.ERROR_ERROR]: 'Error',
        [FM.ERROR_WARNING]: 'Warning',
        [FM.ERROR_PRIMARYBUTTON_ARIADESCRIPTION]: 'Ok',
        [FM.ERROR_PRIMARYBUTTON_TEXT]: 'Ok',
        [FM.ERROR_TOOMANYCHARACTERS]: 'Current value exceeds maximum supported length.',

        // ExtractConflictModal
        [FM.EXTRACTCONFLICTMODAL_TITLE]: 'Inconsistent Entity Labels',
        [FM.EXTRACTCONFLICTMODAL_SUBTITLE]: 'You attempted to submit an input with entities labelled differently than another input in the current or a previous train dialog. Input labels must be consistent to ensure the Bot processes them correctly.',
        [FM.EXTRACTCONFLICTMODAL_REVIEW]: 'Please review the labels below:',
        [FM.EXTRACTCONFLICTMODAL_CONFLICTING_LABELS]: 'Conflicting Labels',
        [FM.EXTRACTCONFLICTMODAL_CORRECT_LABELS]: 'Previously Submitted Labels',
        [FM.EXTRACTCONFLICTMODAL_CALLTOACTION]: `Clicking 'Accept' will replace the conflicting labels with the previously submitted labels.`,

        // LogConversionConflictModal
        [FM.LOGCONVERSIONCONFLICTMODAL_TITLE]: 'Incompatible Log Dialog',
        [FM.LOGCONVERSIONCONFLICTMODAL_SUBTITLE]: 'You attempted to save this log dialog as a train dialog but this dialog is incompatible with the current model due to conflicts in entity labels.  This may occur if the model has changed from the version of model used to create the log dialog. You need to update the dialog to match current model to convert it.',
        [FM.LOGCONVERSIONCONFLICTMODAL_REVIEW]: 'The log dialog contains {conflictCount} conflicts. Please review the changes to labels for each conflict below:',
        [FM.LOGCONVERSIONCONFLICTMODAL_BUTTON_EXPLANATION]: "Clicking 'Accept' will use the previously submitted labels for all conflicts.",
        [FM.LOGCONVERSIONCONFLICTMODAL_ACCEPT]: 'Accept',
        [FM.LOGCONVERSIONCONFLICTMODAL_ABORT]: 'Abort',

        // LogDialogModal
        [FM.LOGDIALOGMODAL_DEFAULTBUTTON_ARIADESCRIPTION]: 'Delete',
        [FM.LOGDIALOGMODAL_DEFAULTBUTTON_TEXT]: 'Delete',
        [FM.LOGDIALOGMODAL_PRIMARYBUTTON_ARIADESCRIPTION]: 'Done',
        [FM.LOGDIALOGMODAL_PRIMARYBUTTON_TEXT]: 'Done',
        [FM.LOGDIALOGMODAL_CONFIRMDELETE_TITLE]: 'Are you sure you want to delete this Log Dialog?',

        // LogoutModal
        [FM.LOGOUT_TITLE]: 'Log Out',
        [FM.LOGOUT_PRIMARYBUTTON_ARIADESCRIPTION]: 'Log Out',
        [FM.LOGOUT_PRIMARYBUTTON_TEXT]: 'Log Out',
        [FM.LOGOUT_DEFAULTBUTTON_ARIADESCRIPTION]: 'Cancel',
        [FM.LOGOUT_DEFAULTBUTTON_TEXT]: 'Cancel',

        // MemoryTable
        [FM.MEMORYTABLE_EMPTY]: 'Empty',

        // Merge
        [FM.MERGE_TITLE]: 'Merge?',
        [FM.MERGE_BODY1]: 'The Dialog you are saving has the same conversation flow and is functionally equivalent with another Train Dialog.',
        [FM.MERGE_BODY2]: 'We suggest merging them to prevent the creation of unneeded TrainDialogs.',
        [FM.MERGE_BODY3]: 'The user inputs at each turn will be combined as Alternative user inputs.',
        [FM.MERGE_BUTTON_MERGE]: 'Merge',
        [FM.MERGE_BUTTON_SAVE]: 'Save As Is',
        [FM.MERGE_LABEL_MERGED]: 'Merged Dialog',
        [FM.MERGE_LABEL_SAVED]: 'This Dialog',
        [FM.MERGE_LABEL_EQUIVALENT]: 'Equivalent Dialog',

        // PackageCreator
        [FM.PACKAGECREATOR_TITLE]: 'Create a new Tag',
        [FM.PACKAGECREATOR_TAG_LABEL]: 'Name',
        [FM.PACKAGECREATOR_TAG_PLACEHOLDER]: 'Tag Name',
        [FM.PACKAGECREATOR_LIVE_LABEL]: 'Make Live Version',
        [FM.PACKAGECREATOR_CREATEBUTTON_ARIADESCRIPTION]: 'Create',
        [FM.PACKAGECREATOR_CREATEBUTTON_TEXT]: 'Create',
        [FM.PACKAGECREATOR_CANCELBUTTON_ARIADESCRIPTION]: 'Cancel',
        [FM.PACKAGECREATOR_CANCELBUTTON_TEXT]: 'Cancel',

        // TagsInput
        [FM.TAGSINPUT_ADD]: 'Add Tag',
        [FM.TAGSINPUT_ERROR_DUPLICATE]: 'The new tag is a duplicate of an existing tag.',
        [FM.TAGSINPUT_READONLY_EMPTY]: 'No Tags',

        // TeachSessionAdmin
        [FM.TEACHSESSIONADMIN_DIALOGMODE_USER]: 'User Input',
        [FM.TEACHSESSIONADMIN_DIALOGMODE_BOT]: 'Bot Response',
        [FM.TEACHSESSIONADMIN_DIALOGMODE_END_SESSION]: 'Session Has Ended',
        [FM.TEACHSESSIONADMIN_MEMORY_TITLE]: 'Memory',
        [FM.TEACHSESSIONADMIN_ENTITYDETECTION_TITLE]: 'Entity Detection',
        [FM.TEACHSESSIONADMIN_ACTION_TITLE]: 'Action',

        [FM.TEACHSESSIONINIT_INPUT_PLACEHOLDER]: 'Initial value...',
        [FM.TEACHSESSIONINIT_TITLE]: 'Set Initial Entity Values',

        // TeachSessionModal
        [FM.TEACHSESSIONMODAL_TEACH_CONFIRMDELETE_TITLE]: 'Are you sure you want to abandon this dialog?',
        [FM.TEACHSESSIONMODAL_EDIT_CONFIRMDELETE_TITLE]: 'Are you sure you want to abandon your edits?',
        [FM.TEACHSESSIONMODAL_INITSTATE_ARIADESCRIPTION]: 'Set Initial State',
        [FM.TEACHSESSIONMODAL_INITSTATE_TEXT]: 'Set Initial State',

        // EditDialogAdmin
        [FM.EDITDIALOGADMIN_DIALOGMODE_USER]: 'User Input',
        [FM.EDITDIALOGADMIN_DIALOGMODE_TEXT]: 'Bot Response',
        [FM.EDITDIALOGADMIN_MEMORY_TITLE]: 'Memory',
        [FM.EDITDIALOGADMIN_HELPTEXT_TITLE_LOG]: 'Log Dialog',
        [FM.EDITDIALOGADMIN_HELPTEXT_DESCRIPTION_LOG]: 'Click on User or Bot turns in the left panel to view steps in the Log Dialog.',
        [FM.EDITDIALOGADMIN_HELPTEXT_DESCRIPTION2_LOG]: 'You can then make changes to the Log Dialog.',
        [FM.EDITDIALOGADMIN_HELPTEXT_TITLE_TRAIN]: 'Train Dialog',
        [FM.EDITDIALOGADMIN_HELPTEXT_DESCRIPTION_TRAIN]: 'Click on User or Bot turns in the left panel to view steps in the Train Dialog.',
        [FM.EDITDIALOGADMIN_HELPTEXT_DESCRIPTION2_TRAIN]: 'You can then make changes to the Train Dialog.',
        [FM.EDITDIALOGADMIN_ENTITYDETECTION_TITLE]: 'Entity Detection',
        [FM.EDITDIALOGADMIN_ENTITYDETECTION_HELPTEXT]: 'Click on text from the dialog to the left.',
        [FM.EDITDIALOGADMIN_ACTION_TITLE]: 'Action',

        // EditDialogModal
        [FM.EDITDIALOGMODAL_BRANCH_ARIADESCRIPTION]: 'Branch',
        [FM.EDITDIALOGMODAL_BRANCH_TEXT]: 'Branch',
        [FM.EDITDIALOGMODAL_BRANCH_TIP]: 'First select a round in the conversation by clicking on it.  Then click "Branch" to create a new Training Dialog starting at that round.',
        [FM.EDITDIALOGMODAL_CANTBRANCH_TITLE]: 'This Train Dialog has errors that must be resolved before it can be branched',
        [FM.EDITDIALOGMODAL_CANTREPLAY_TITLE]: 'This Train Dialog has errors that must be resolved before a new round can be inserted',
        [FM.EDITDIALOGMODAL_CONFIRMDELETELOG_TITLE]: 'Are you sure you want to delete this Log Dialog?',
        [FM.EDITDIALOGMODAL_CONFIRMDELETETRAIN_TITLE]: 'Are you sure you want to delete this Training Dialog?',
        [FM.EDITDIALOGMODAL_CONFIRMABANDON_NEW_TITLE]: 'Are you sure you want to abandon this Training Dialog?',
        [FM.EDITDIALOGMODAL_CONFIRMABANDON_EDIT_TITLE]: 'Are you sure you want to abandon your edits?',
        [FM.EDITDIALOGMODAL_SAVECONFLICT_TITLE]: 'Previous edits require that you save this dialog before taking this action',
        [FM.EDITDIALOGMODAL_WARNING_INVALID_BOT]: 'Running Bot not compatible with this Model',
        [FM.EDITDIALOGMODAL_WARNING_INVALID_PACKAGE]: 'Editing only permitted on the Master tag',
        [FM.EDITDIALOGMODAL_UNKNOWN_NEED_REPLAY]: 'Entity or Action changes require replay of the TrainDialog',
        [FM.EDITDIALOGMODAL_WARNING_NEED_REPLAY]: 'Entity or Action changes require replay of the TrainDialog',

        // UserInput Modal
        [FM.USERINPUT_ADD_TITLE]: 'Add User Input',
        [FM.USERINPUT_BRANCH_TITLE]: 'Add Different User Input',
        [FM.USERINPUT_PLACEHOLDER]: 'User Input...',

        /** 
         * This is kind of hack which re-uses redux action types as unit strings for localized error messages
         * 
         * It should probably be `errors.application.create` but we're using something like: `CREATE_APPLICATION_ASYNC`
         */
        [AT.CREATE_APPLICATION_ASYNC]: 'Creating Application',
        [AT.COPY_APPLICATION_ASYNC]: 'Copying Application ',
        [AT.CREATE_ENTITY_ASYNC]: 'Creating Entity',
        [AT.CREATE_ACTION_ASYNC]: 'Creating Action',
        [AT.CREATE_APP_TAG_ASYNC]: 'Creating Application Tag',
        [AT.CREATE_CHAT_SESSION_ASYNC]: 'Creating Chat Session',
        [AT.CREATE_TEACH_SESSION_ASYNC]: 'Creating Teach Session',
        [AT.CREATE_TEACH_SESSION_FROMHISTORY_ASYNC]: 'Creating Teach Session from history',
        [AT.CREATE_TRAIN_DIALOG_ASYNC]: 'Creating Train Dialog',
        [AT.FETCH_BOTINFO_ASYNC]: 'Fetching Bot information',
        [AT.FETCH_HISTORY_ASYNC]: 'Fetching history',
        [AT.FETCH_TUTORIALS_ASYNC]: 'Fetching tutorials',
        [AT.FETCH_APPSOURCE_ASYNC]: 'Fetching Application source',
        [AT.FETCH_ENTITY_DELETE_VALIDATION_ASYNC]: 'Fetching entity deletion information',
        [AT.FETCH_ENTITY_EDIT_VALIDATION_ASYNC]: 'Fetching entity edit information',
        [AT.FETCH_ACTION_DELETE_VALIDATION_ASYNC]: 'Fetching action delete information',
        [AT.FETCH_ACTION_EDIT_VALIDATION_ASYNC]: 'Fetching action edit information',
        [AT.RUN_EXTRACTOR_ASYNC]: 'Running extractor',
        [AT.GET_SCORES_ASYNC]: 'Fetching scores',
        [AT.RUN_SCORER_ASYNC]: 'Running scorer',
        [AT.POST_SCORE_FEEDBACK_ASYNC]: 'Fetching score feedback',
        [AT.EDIT_ENTITY_ASYNC]: 'Editing Entity',
        [AT.EDIT_ACTION_ASYNC]: 'Editing Action',
        [AT.EDIT_TRAINDIALOG_ASYNC]: 'Editing Train Dialog',
        [AT.EDIT_TRAINDIALOG_MERGE_ASYNC]: 'Merging Train Dialog',
        [AT.EDIT_TRAINDIALOG_REPLACE_ASYNC]: 'Replacing Train Dialog',
        [AT.EDIT_APP_LIVE_TAG_ASYNC]: 'Editing Application live tag',
        [AT.EDIT_APP_EDITING_TAG_ASYNC]: 'Editing Application editing tag',
    },
    'ko': {
        [FM.ABOUT_TITLE]: '약',
        [FM.DOCS_TITLE]: '선적 서류 비치',
        [FM.LOGIN_TITLE]: '로그인',
        [FM.SUPPORT_TITLE]: '지원하다',
        [FM.NOMATCH_TITLE]: '페이지를 찾을 수 없습니다.',
        [FM.NOMATCH_HOME]: '집',
        [FM.PAGE_COMINGSOON]: '출시 예정 ...',

        // App
        [FM.APP_HEADER_MODELS]: '집',
        [FM.APP_HEADER_ABOUT]: '약',
        [FM.APP_HEADER_DOCS]: '선적 서류 비치',
        [FM.APP_HEADER_SUPPORT]: '지원하다',
        [FM.APPSLIST_CONFIRMCANCELMODALTITLE]: '이 애플리케이션을 삭제 하시겠습니까?',
        [FM.APPSLIST_COLUMN_NAME]: '이름',
        [FM.APPSLIST_COLUMNS_LOCALE]: '장소',
        [FM.APPSLIST_COLUMNS_LINKEDBOTS]: '연결된 봇',
        [FM.APPSLIST_COLUMNS_ACTIONS]: '행위',

        // Apps List
        [FM.APPSLIST_SUBTITLE]: '내 앱',
        [FM.APPSLIST_SUBTITLE]: 'Conversation Learner 응용 프로그램 작성 및 관리 ...',
        [FM.APPSLIST_CREATEBUTTONARIADESCRIPTION]: '새 응용 프로그램 만들기',
        [FM.APPSLIST_CREATEBUTTONTEXT]: '새 앱',

        // TODO: I think there are special localization experts within Microsoft who can fill this in for us.
    }
}


// WEBPACK FOOTER //
// ./src/react-intl-messages.ts